var items = {
  "block.minecraft.acacia_button": "Akacova knopka",
  "block.minecraft.acacia_door": "Akacove dveri",
  "block.minecraft.acacia_fence": "Akacova ograda",
  "block.minecraft.acacia_fence_gate": "Akacove vrata",
  "block.minecraft.acacia_hanging_sign": "Pověšena akacova vyvěska",
  "block.minecraft.acacia_leaves": "Akacove listy",
  "block.minecraft.acacia_log": "Akacova klada",
  "block.minecraft.acacia_planks": "Akacove dosky",
  "block.minecraft.acacia_pressure_plate": "Akacovy pritiskany platform",
  "block.minecraft.acacia_sapling": "Akacovy rastok",
  "block.minecraft.acacia_shelf": "Akacova polica",
  "block.minecraft.acacia_sign": "Akacova vyvěska",
  "block.minecraft.acacia_slab": "Akacovy platform",
  "block.minecraft.acacia_stairs": "Akacove stupenišče",
  "block.minecraft.acacia_trapdoor": "Akacovy otvor",
  "block.minecraft.acacia_wall_hanging_sign": "Nastěnna pověšena akacova vyvěska",
  "block.minecraft.acacia_wall_sign": "Nastěnna akacova vyvěska",
  "block.minecraft.acacia_wood": "Akacovo drěvo",
  "block.minecraft.activator_rail": "Aktivujuča kolěja",
  "block.minecraft.air": "Vozduh",
  "block.minecraft.allium": "Česnok",
  "block.minecraft.amethyst_block": "Blok ametista",
  "block.minecraft.amethyst_cluster": "Grozd ametista",
  "block.minecraft.ancient_debris": "Drěvny ulomok",
  "block.minecraft.andesite": "Andezit",
  "block.minecraft.andesite_slab": "Andezitovy platform",
  "block.minecraft.andesite_stairs": "Andezitove stupenišče",
  "block.minecraft.andesite_wall": "Andezitova stěna",
  "block.minecraft.anvil": "Nakovaljnja",
  "block.minecraft.attached_melon_stem": "Prilučeno steblo dynje",
  "block.minecraft.attached_pumpkin_stem": "Prilučeno steblo tykvy",
  "block.minecraft.azalea": "Azalija",
  "block.minecraft.azalea_leaves": "Listy azaliji",
  "block.minecraft.azure_bluet": "Modra haustonja",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Blok bambusa",
  "block.minecraft.bamboo_button": "Bambusova knopka",
  "block.minecraft.bamboo_door": "Bambusove dveri",
  "block.minecraft.bamboo_fence": "Bambusova ograda",
  "block.minecraft.bamboo_fence_gate": "Bambusove vrata",
  "block.minecraft.bamboo_hanging_sign": "Pověšena bambusova vyvěska",
  "block.minecraft.bamboo_mosaic": "Bambusovy mozaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusovy mozaičny platform",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusove mozaične stupenišče",
  "block.minecraft.bamboo_planks": "Bambusove dosky",
  "block.minecraft.bamboo_pressure_plate": "Bambusovy pritiskany platform",
  "block.minecraft.bamboo_sapling": "Bambusovy rastok",
  "block.minecraft.bamboo_shelf": "Bambusova polica",
  "block.minecraft.bamboo_sign": "Bambusova vyvěska",
  "block.minecraft.bamboo_slab": "Bambusovy platform",
  "block.minecraft.bamboo_stairs": "Bambusove stupenišče",
  "block.minecraft.bamboo_trapdoor": "Bambusovy otvor",
  "block.minecraft.bamboo_wall_hanging_sign": "Nastěnna pověšena bambusova vyvěska",
  "block.minecraft.bamboo_wall_sign": "Nastěnna bambusova vyvěska",
  "block.minecraft.banner.base.black": "Črna baza",
  "block.minecraft.banner.base.blue": "Modra baza",
  "block.minecraft.banner.base.brown": "Koričneva baza",
  "block.minecraft.banner.base.cyan": "Turkysova baza",
  "block.minecraft.banner.base.gray": "Siva baza",
  "block.minecraft.banner.base.green": "Zelena baza",
  "block.minecraft.banner.base.light_blue": "Světlomodra baza",
  "block.minecraft.banner.base.light_gray": "Jasnosiva baza",
  "block.minecraft.banner.base.lime": "Jasnozelena baza",
  "block.minecraft.banner.base.magenta": "Purpurna baza",
  "block.minecraft.banner.base.orange": "Oranževa baza",
  "block.minecraft.banner.base.pink": "Rozova baza",
  "block.minecraft.banner.base.purple": "Fioletova baza",
  "block.minecraft.banner.base.red": "Črvena baza",
  "block.minecraft.banner.base.white": "Běla baza",
  "block.minecraft.banner.base.yellow": "Žolta baza",
  "block.minecraft.banner.border.black": "Črny obrub",
  "block.minecraft.banner.border.blue": "Modry obrub",
  "block.minecraft.banner.border.brown": "Koričnevy obrub",
  "block.minecraft.banner.border.cyan": "Turkysovy obrub",
  "block.minecraft.banner.border.gray": "Sivy obrub",
  "block.minecraft.banner.border.green": "Zeleny obrub",
  "block.minecraft.banner.border.light_blue": "Světlomodry obrub",
  "block.minecraft.banner.border.light_gray": "Jasnosivy obrub",
  "block.minecraft.banner.border.lime": "Jasnozeleny obrub",
  "block.minecraft.banner.border.magenta": "Purpurny obrub",
  "block.minecraft.banner.border.orange": "Oranževy obrub",
  "block.minecraft.banner.border.pink": "Rozovy obrub",
  "block.minecraft.banner.border.purple": "Fioletovy obrub",
  "block.minecraft.banner.border.red": "Črveny obrub",
  "block.minecraft.banner.border.white": "Běly obrub",
  "block.minecraft.banner.border.yellow": "Žolty obrub",
  "block.minecraft.banner.bricks.black": "Črny črtež cegl",
  "block.minecraft.banner.bricks.blue": "Modry črtež cegl",
  "block.minecraft.banner.bricks.brown": "Koričnevy črtež cegl",
  "block.minecraft.banner.bricks.cyan": "Turkysovy črtež cegl",
  "block.minecraft.banner.bricks.gray": "Sivy črtež cegl",
  "block.minecraft.banner.bricks.green": "Zeleny črtež cegl",
  "block.minecraft.banner.bricks.light_blue": "Světlomodry črtež cegl",
  "block.minecraft.banner.bricks.light_gray": "Jasnosivy črtež cegl",
  "block.minecraft.banner.bricks.lime": "Jasnozeleny črtež cegl",
  "block.minecraft.banner.bricks.magenta": "Purpurny črtež cegl",
  "block.minecraft.banner.bricks.orange": "Oranževy črtež cegl",
  "block.minecraft.banner.bricks.pink": "Rozovy črtež cegl",
  "block.minecraft.banner.bricks.purple": "Fioletovy črtež cegl",
  "block.minecraft.banner.bricks.red": "Črveny črtež cegl",
  "block.minecraft.banner.bricks.white": "Běly črtež cegl",
  "block.minecraft.banner.bricks.yellow": "Žolty črtež cegl",
  "block.minecraft.banner.circle.black": "Črny krug",
  "block.minecraft.banner.circle.blue": "Modry krug",
  "block.minecraft.banner.circle.brown": "Koričnevy krug",
  "block.minecraft.banner.circle.cyan": "Turkysovy krug",
  "block.minecraft.banner.circle.gray": "Sivy krug",
  "block.minecraft.banner.circle.green": "Zeleny krug",
  "block.minecraft.banner.circle.light_blue": "Světlomodry krug",
  "block.minecraft.banner.circle.light_gray": "Jasnosivy krug",
  "block.minecraft.banner.circle.lime": "Jasnozeleny krug",
  "block.minecraft.banner.circle.magenta": "Purpurny krug",
  "block.minecraft.banner.circle.orange": "Oranževy krug",
  "block.minecraft.banner.circle.pink": "Rozovy krug",
  "block.minecraft.banner.circle.purple": "Fioletovy krug",
  "block.minecraft.banner.circle.red": "Črveny krug",
  "block.minecraft.banner.circle.white": "Běly krug",
  "block.minecraft.banner.circle.yellow": "Žolty krug",
  "block.minecraft.banner.creeper.black": "Črny črtež kripera",
  "block.minecraft.banner.creeper.blue": "Modry črtež kripera",
  "block.minecraft.banner.creeper.brown": "Koričnevy črtež kripera",
  "block.minecraft.banner.creeper.cyan": "Turkysovy črtež kripera",
  "block.minecraft.banner.creeper.gray": "Sivy črtež kripera",
  "block.minecraft.banner.creeper.green": "Zeleny črtež kripera",
  "block.minecraft.banner.creeper.light_blue": "Světlomodry črtež kripera",
  "block.minecraft.banner.creeper.light_gray": "Jasnosivy črtež kripera",
  "block.minecraft.banner.creeper.lime": "Jasnozeleny črtež kripera",
  "block.minecraft.banner.creeper.magenta": "Purpurny črtež kripera",
  "block.minecraft.banner.creeper.orange": "Oranževy črtež kripera",
  "block.minecraft.banner.creeper.pink": "Rozovy črtež kripera",
  "block.minecraft.banner.creeper.purple": "Fioletovy črtež kripera",
  "block.minecraft.banner.creeper.red": "Črveny črtež kripera",
  "block.minecraft.banner.creeper.white": "Běly črtež kripera",
  "block.minecraft.banner.creeper.yellow": "Žolty črtež kripera",
  "block.minecraft.banner.cross.black": "Črny križ",
  "block.minecraft.banner.cross.blue": "Modry križ",
  "block.minecraft.banner.cross.brown": "Koričnevy križ",
  "block.minecraft.banner.cross.cyan": "Turkysovy križ",
  "block.minecraft.banner.cross.gray": "Sivy križ",
  "block.minecraft.banner.cross.green": "Zeleny križ",
  "block.minecraft.banner.cross.light_blue": "Světlomodry križ",
  "block.minecraft.banner.cross.light_gray": "Jasnosivy križ",
  "block.minecraft.banner.cross.lime": "Jasnozeleny križ",
  "block.minecraft.banner.cross.magenta": "Purpurny križ",
  "block.minecraft.banner.cross.orange": "Oranževy križ",
  "block.minecraft.banner.cross.pink": "Rozovy križ",
  "block.minecraft.banner.cross.purple": "Fioletovy križ",
  "block.minecraft.banner.cross.red": "Črveny križ",
  "block.minecraft.banner.cross.white": "Běly križ",
  "block.minecraft.banner.cross.yellow": "Žolty križ",
  "block.minecraft.banner.curly_border.black": "Črny obrub s odstupom",
  "block.minecraft.banner.curly_border.blue": "Modry obrub s odstupom",
  "block.minecraft.banner.curly_border.brown": "Koričnevy obrub s odstupom",
  "block.minecraft.banner.curly_border.cyan": "Turkysovy obrub s odstupom",
  "block.minecraft.banner.curly_border.gray": "Sivy obrub s odstupom",
  "block.minecraft.banner.curly_border.green": "Zeleny obrub s odstupom",
  "block.minecraft.banner.curly_border.light_blue": "Světlomodry obrub s odstupom",
  "block.minecraft.banner.curly_border.light_gray": "Jasnosivy obrub s odstupom",
  "block.minecraft.banner.curly_border.lime": "Jasnozeleny obrub s odstupom",
  "block.minecraft.banner.curly_border.magenta": "Purpurny obrub s odstupom",
  "block.minecraft.banner.curly_border.orange": "Oranževy obrub s odstupom",
  "block.minecraft.banner.curly_border.pink": "Rozovy obrub s odstupom",
  "block.minecraft.banner.curly_border.purple": "Fioletovy obrub s odstupom",
  "block.minecraft.banner.curly_border.red": "Črveny obrub s odstupom",
  "block.minecraft.banner.curly_border.white": "Běly obrub s odstupom",
  "block.minecraft.banner.curly_border.yellow": "Žolty obrub s odstupom",
  "block.minecraft.banner.diagonal_left.black": "Črny trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.blue": "Modry trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.brown": "Koričnevy trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.cyan": "Turkysovy trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.gray": "Sivy trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.green": "Zeleny trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.light_blue": "Světlomodry trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.light_gray": "Jasnosivy trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.lime": "Jasnozeleny trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.magenta": "Purpurny trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.orange": "Oranževy trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.pink": "Rozovy trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.purple": "Fioletovy trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.red": "Črveny trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.white": "Běly trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_left.yellow": "Žolty trivugolnik vo vrhnym lěvym kutu",
  "block.minecraft.banner.diagonal_right.black": "Črny trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.blue": "Modry trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.brown": "Koričnevy trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.cyan": "Turkysovy trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.gray": "Sivy trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.green": "Zeleny trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.light_blue": "Světlomodry trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.light_gray": "Jasnosivy trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.lime": "Jasnozeleny trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.magenta": "Purpurny trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.orange": "Oranževy trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.pink": "Rozovy trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.purple": "Fioletovy trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.red": "Črveny trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.white": "Běly trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_right.yellow": "Žolty trivugolnik vo vrhnym pravym kutu",
  "block.minecraft.banner.diagonal_up_left.black": "Črny trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.blue": "Modry trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.brown": "Koričnevy trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.cyan": "Turkysovy trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.gray": "Sivy trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.green": "Zeleny trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Světlomodry trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Jasnosivy trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.lime": "Jasnozeleny trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.magenta": "Purpurny trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranževy trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.pink": "Rozovy trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.purple": "Fioletovy trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.red": "Črveny trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.white": "Běly trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_left.yellow": "Žolty trivugolnik v dolnym lěvym kutu",
  "block.minecraft.banner.diagonal_up_right.black": "Črny trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.blue": "Modry trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.brown": "Koričnevy trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.cyan": "Turkysovy trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.gray": "Sivy trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.green": "Zeleny trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Světlomodry trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Jasnosivy trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.lime": "Jasnozeleny trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.magenta": "Purpurny trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranževy trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.pink": "Rozovy trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.purple": "Fioletovy trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.red": "Črveny trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.white": "Běly trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.diagonal_up_right.yellow": "Žolty trivugolnik v dolnym pravym kutu",
  "block.minecraft.banner.flow.black": "Črny tok",
  "block.minecraft.banner.flow.blue": "Modry tok",
  "block.minecraft.banner.flow.brown": "Koričnevy tok",
  "block.minecraft.banner.flow.cyan": "Turkysovy tok",
  "block.minecraft.banner.flow.gray": "Sivy tok",
  "block.minecraft.banner.flow.green": "Zeleny tok",
  "block.minecraft.banner.flow.light_blue": "Světlomodry tok",
  "block.minecraft.banner.flow.light_gray": "Jasnosivy tok",
  "block.minecraft.banner.flow.lime": "Jasnozeleny tok",
  "block.minecraft.banner.flow.magenta": "Purpurny tok",
  "block.minecraft.banner.flow.orange": "Oranževy tok",
  "block.minecraft.banner.flow.pink": "Rozovy tok",
  "block.minecraft.banner.flow.purple": "Fioletovy tok",
  "block.minecraft.banner.flow.red": "Črveny tok",
  "block.minecraft.banner.flow.white": "Běly tok",
  "block.minecraft.banner.flow.yellow": "Žolty tok",
  "block.minecraft.banner.flower.black": "Črny črtež cvěta",
  "block.minecraft.banner.flower.blue": "Modry črtež cvěta",
  "block.minecraft.banner.flower.brown": "Koričnevy črtež cvěta",
  "block.minecraft.banner.flower.cyan": "Turkysovy črtež cvěta",
  "block.minecraft.banner.flower.gray": "Sivy črtež cvěta",
  "block.minecraft.banner.flower.green": "Zeleny črtež cvěta",
  "block.minecraft.banner.flower.light_blue": "Světlomodry črtež cvěta",
  "block.minecraft.banner.flower.light_gray": "Jasnosivy črtež cvěta",
  "block.minecraft.banner.flower.lime": "Jasnozeleny črtež cvěta",
  "block.minecraft.banner.flower.magenta": "Purpurny črtež cvěta",
  "block.minecraft.banner.flower.orange": "Oranževy črtež cvěta",
  "block.minecraft.banner.flower.pink": "Rozovy črtež cvěta",
  "block.minecraft.banner.flower.purple": "Fioletovy črtež cvěta",
  "block.minecraft.banner.flower.red": "Črveny črtež cvěta",
  "block.minecraft.banner.flower.white": "Běly črtež cvěta",
  "block.minecraft.banner.flower.yellow": "Žolty črtež cvěta",
  "block.minecraft.banner.globe.black": "Črny globus",
  "block.minecraft.banner.globe.blue": "Modry globus",
  "block.minecraft.banner.globe.brown": "Koričnevy globus",
  "block.minecraft.banner.globe.cyan": "Turkysovy globus",
  "block.minecraft.banner.globe.gray": "Sivy globus",
  "block.minecraft.banner.globe.green": "Zeleny globus",
  "block.minecraft.banner.globe.light_blue": "Světlomodry globus",
  "block.minecraft.banner.globe.light_gray": "Jasnosivy globus",
  "block.minecraft.banner.globe.lime": "Jasnozeleny globus",
  "block.minecraft.banner.globe.magenta": "Purpurny globus",
  "block.minecraft.banner.globe.orange": "Oranževy globus",
  "block.minecraft.banner.globe.pink": "Rozovy globus",
  "block.minecraft.banner.globe.purple": "Fioletovy globus",
  "block.minecraft.banner.globe.red": "Črveny globus",
  "block.minecraft.banner.globe.white": "Běly globus",
  "block.minecraft.banner.globe.yellow": "Žolty globus",
  "block.minecraft.banner.gradient.black": "Črny směs",
  "block.minecraft.banner.gradient.blue": "Modry směs",
  "block.minecraft.banner.gradient.brown": "Koričnevy směs",
  "block.minecraft.banner.gradient.cyan": "Turkysovy směs",
  "block.minecraft.banner.gradient.gray": "Sivy směs",
  "block.minecraft.banner.gradient.green": "Zeleny směs",
  "block.minecraft.banner.gradient.light_blue": "Světlomodry směs",
  "block.minecraft.banner.gradient.light_gray": "Jasnosivy směs",
  "block.minecraft.banner.gradient.lime": "Jasnozeleny směs",
  "block.minecraft.banner.gradient.magenta": "Purpurny směs",
  "block.minecraft.banner.gradient.orange": "Oranževy směs",
  "block.minecraft.banner.gradient.pink": "Rozovy směs",
  "block.minecraft.banner.gradient.purple": "Fioletovy směs",
  "block.minecraft.banner.gradient.red": "Črveny směs",
  "block.minecraft.banner.gradient.white": "Běly směs",
  "block.minecraft.banner.gradient.yellow": "Žolty směs",
  "block.minecraft.banner.gradient_up.black": "Črny podstavovy směs",
  "block.minecraft.banner.gradient_up.blue": "Modry podstavovy směs",
  "block.minecraft.banner.gradient_up.brown": "Koričnevy podstavovy směs",
  "block.minecraft.banner.gradient_up.cyan": "Turkysovy podstavovy směs",
  "block.minecraft.banner.gradient_up.gray": "Sivy podstavovy směs",
  "block.minecraft.banner.gradient_up.green": "Zeleny podstavovy směs",
  "block.minecraft.banner.gradient_up.light_blue": "Světlomodry podstavovy směs",
  "block.minecraft.banner.gradient_up.light_gray": "Jasnosivy podstavovy směs",
  "block.minecraft.banner.gradient_up.lime": "Jasnozeleny podstavovy směs",
  "block.minecraft.banner.gradient_up.magenta": "Purpurny podstavovy směs",
  "block.minecraft.banner.gradient_up.orange": "Oranževy podstavovy směs",
  "block.minecraft.banner.gradient_up.pink": "Rozovy podstavovy směs",
  "block.minecraft.banner.gradient_up.purple": "Fioletovy podstavovy směs",
  "block.minecraft.banner.gradient_up.red": "Črveny podstavovy směs",
  "block.minecraft.banner.gradient_up.white": "Běly podstavovy směs",
  "block.minecraft.banner.gradient_up.yellow": "Žolty podstavovy směs",
  "block.minecraft.banner.guster.black": "Črny poryv",
  "block.minecraft.banner.guster.blue": "Modry poryv",
  "block.minecraft.banner.guster.brown": "Koričnevy poryv",
  "block.minecraft.banner.guster.cyan": "Turkusovy poryv",
  "block.minecraft.banner.guster.gray": "Sivy poryv",
  "block.minecraft.banner.guster.green": "Zeleny poryv",
  "block.minecraft.banner.guster.light_blue": "Světlomodry poryv",
  "block.minecraft.banner.guster.light_gray": "Jasnosivy poryv",
  "block.minecraft.banner.guster.lime": "Jasnozeleny poryv",
  "block.minecraft.banner.guster.magenta": "Purpurny poryv",
  "block.minecraft.banner.guster.orange": "Oranževy poryv",
  "block.minecraft.banner.guster.pink": "Rozovy poryv",
  "block.minecraft.banner.guster.purple": "Fioletovy poryv",
  "block.minecraft.banner.guster.red": "Črveny poryv",
  "block.minecraft.banner.guster.white": "Běly poryv",
  "block.minecraft.banner.guster.yellow": "Žolty poryv",
  "block.minecraft.banner.half_horizontal.black": "Črny vrhny pol",
  "block.minecraft.banner.half_horizontal.blue": "Modry vrhny pol",
  "block.minecraft.banner.half_horizontal.brown": "Koričnevy vrhny pol",
  "block.minecraft.banner.half_horizontal.cyan": "Turkysovy vrhny pol",
  "block.minecraft.banner.half_horizontal.gray": "Sivy vrhny pol",
  "block.minecraft.banner.half_horizontal.green": "Zeleny vrhny pol",
  "block.minecraft.banner.half_horizontal.light_blue": "Světlomodry vrhny pol",
  "block.minecraft.banner.half_horizontal.light_gray": "Jasnosivy vrhny pol",
  "block.minecraft.banner.half_horizontal.lime": "Jasnozeleny vrhny pol",
  "block.minecraft.banner.half_horizontal.magenta": "Purpurny vrhny pol",
  "block.minecraft.banner.half_horizontal.orange": "Oranževy vrhny pol",
  "block.minecraft.banner.half_horizontal.pink": "Rozovy vrhny pol",
  "block.minecraft.banner.half_horizontal.purple": "Fioletovy vrhny pol",
  "block.minecraft.banner.half_horizontal.red": "Črveny vrhny pol",
  "block.minecraft.banner.half_horizontal.white": "Běly vrhny pol",
  "block.minecraft.banner.half_horizontal.yellow": "Žolty vrhny pol",
  "block.minecraft.banner.half_horizontal_bottom.black": "Črny dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Modry dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Koričnevy dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Turkysovy dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Sivy dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zeleny dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Světlomodry dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Jasnosivy dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Jasnozeleny dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Purpurny dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranževy dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rozovy dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Fioletovy dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.red": "Črveny dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.white": "Běly dolny pol",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Žolty dolny pol",
  "block.minecraft.banner.half_vertical.black": "Črny lěvy pol",
  "block.minecraft.banner.half_vertical.blue": "Modry lěvy pol",
  "block.minecraft.banner.half_vertical.brown": "Koričnevy lěvy pol",
  "block.minecraft.banner.half_vertical.cyan": "Turkysovy lěvy pol",
  "block.minecraft.banner.half_vertical.gray": "Sivy lěvy pol",
  "block.minecraft.banner.half_vertical.green": "Zeleny lěvy pol",
  "block.minecraft.banner.half_vertical.light_blue": "Světlomodry lěvy pol",
  "block.minecraft.banner.half_vertical.light_gray": "Jasnosivy lěvy pol",
  "block.minecraft.banner.half_vertical.lime": "Jasnozeleny lěvy pol",
  "block.minecraft.banner.half_vertical.magenta": "Purpurny lěvy pol",
  "block.minecraft.banner.half_vertical.orange": "Oranževy lěvy pol",
  "block.minecraft.banner.half_vertical.pink": "Rozovy lěvy pol",
  "block.minecraft.banner.half_vertical.purple": "Fioletovy lěvy pol",
  "block.minecraft.banner.half_vertical.red": "Črveny lěvy pol",
  "block.minecraft.banner.half_vertical.white": "Běly lěvy pol",
  "block.minecraft.banner.half_vertical.yellow": "Žolty lěvy pol",
  "block.minecraft.banner.half_vertical_right.black": "Črny pravy pol",
  "block.minecraft.banner.half_vertical_right.blue": "Modry pravy pol",
  "block.minecraft.banner.half_vertical_right.brown": "Koričnevy pravy pol",
  "block.minecraft.banner.half_vertical_right.cyan": "Turkysovy pravy pol",
  "block.minecraft.banner.half_vertical_right.gray": "Sivy pravy pol",
  "block.minecraft.banner.half_vertical_right.green": "Zeleny pravy pol",
  "block.minecraft.banner.half_vertical_right.light_blue": "Světlomodry pravy pol",
  "block.minecraft.banner.half_vertical_right.light_gray": "Jasnosivy pravy pol",
  "block.minecraft.banner.half_vertical_right.lime": "Jasnozeleny pravy pol",
  "block.minecraft.banner.half_vertical_right.magenta": "Purpurny pravy pol",
  "block.minecraft.banner.half_vertical_right.orange": "Oranževy pravy pol",
  "block.minecraft.banner.half_vertical_right.pink": "Rozovy pravy pol",
  "block.minecraft.banner.half_vertical_right.purple": "Fioletovy pravy pol",
  "block.minecraft.banner.half_vertical_right.red": "Črveny pravy pol",
  "block.minecraft.banner.half_vertical_right.white": "Běly pravy pol",
  "block.minecraft.banner.half_vertical_right.yellow": "Žolty pravy pol",
  "block.minecraft.banner.mojang.black": "Črny prědmet",
  "block.minecraft.banner.mojang.blue": "Modry prědmet",
  "block.minecraft.banner.mojang.brown": "Koričnevy prědmet",
  "block.minecraft.banner.mojang.cyan": "Turkysovy prědmet",
  "block.minecraft.banner.mojang.gray": "Sivy prědmet",
  "block.minecraft.banner.mojang.green": "Zeleny prědmet",
  "block.minecraft.banner.mojang.light_blue": "Světlomodry prědmet",
  "block.minecraft.banner.mojang.light_gray": "Jasnosivy prědmet",
  "block.minecraft.banner.mojang.lime": "Jasnozeleny prědmet",
  "block.minecraft.banner.mojang.magenta": "Purpurny prědmet",
  "block.minecraft.banner.mojang.orange": "Oranževy prědmet",
  "block.minecraft.banner.mojang.pink": "Rozovy prědmet",
  "block.minecraft.banner.mojang.purple": "Fioletovy prědmet",
  "block.minecraft.banner.mojang.red": "Črveny prědmet",
  "block.minecraft.banner.mojang.white": "Běly prědmet",
  "block.minecraft.banner.mojang.yellow": "Žolty prědmet",
  "block.minecraft.banner.piglin.black": "Črno rylo",
  "block.minecraft.banner.piglin.blue": "Modro rylo",
  "block.minecraft.banner.piglin.brown": "Koričnevo rylo",
  "block.minecraft.banner.piglin.cyan": "Turkysovo rylo",
  "block.minecraft.banner.piglin.gray": "Sivo rylo",
  "block.minecraft.banner.piglin.green": "Zeleno rylo",
  "block.minecraft.banner.piglin.light_blue": "Světlomodro rylo",
  "block.minecraft.banner.piglin.light_gray": "Jasnosivo rylo",
  "block.minecraft.banner.piglin.lime": "Jasnozeleno rylo",
  "block.minecraft.banner.piglin.magenta": "Purpurno rylo",
  "block.minecraft.banner.piglin.orange": "Oranževo rylo",
  "block.minecraft.banner.piglin.pink": "Rozovo rylo",
  "block.minecraft.banner.piglin.purple": "Purpurno rylo",
  "block.minecraft.banner.piglin.red": "Črveno rylo",
  "block.minecraft.banner.piglin.white": "Bělo rylo",
  "block.minecraft.banner.piglin.yellow": "Žolto rylo",
  "block.minecraft.banner.rhombus.black": "Črny romb",
  "block.minecraft.banner.rhombus.blue": "Modry romb",
  "block.minecraft.banner.rhombus.brown": "Koričnevy romb",
  "block.minecraft.banner.rhombus.cyan": "Turkysovy romb",
  "block.minecraft.banner.rhombus.gray": "Sivy romb",
  "block.minecraft.banner.rhombus.green": "Zeleny romb",
  "block.minecraft.banner.rhombus.light_blue": "Světlomodry romb",
  "block.minecraft.banner.rhombus.light_gray": "Jasnosivy romb",
  "block.minecraft.banner.rhombus.lime": "Jasnozeleny romb",
  "block.minecraft.banner.rhombus.magenta": "Purpurny romb",
  "block.minecraft.banner.rhombus.orange": "Oranževy romb",
  "block.minecraft.banner.rhombus.pink": "Rozovy romb",
  "block.minecraft.banner.rhombus.purple": "Fioletovy romb",
  "block.minecraft.banner.rhombus.red": "Črveny romb",
  "block.minecraft.banner.rhombus.white": "Běly romb",
  "block.minecraft.banner.rhombus.yellow": "Žolty romb",
  "block.minecraft.banner.skull.black": "Črny črtež čerepa",
  "block.minecraft.banner.skull.blue": "Modry črtež čerepa",
  "block.minecraft.banner.skull.brown": "Koričnevy črtež čerepa",
  "block.minecraft.banner.skull.cyan": "Turkysovy črtež čerepa",
  "block.minecraft.banner.skull.gray": "Sivy črtež čerepa",
  "block.minecraft.banner.skull.green": "Zeleny črtež čerepa",
  "block.minecraft.banner.skull.light_blue": "Světlomodry črtež čerepa",
  "block.minecraft.banner.skull.light_gray": "Jasnosivy črtež čerepa",
  "block.minecraft.banner.skull.lime": "Jasnozeleny črtež čerepa",
  "block.minecraft.banner.skull.magenta": "Purpurny črtež čerepa",
  "block.minecraft.banner.skull.orange": "Oranževy črtež čerepa",
  "block.minecraft.banner.skull.pink": "Rozovy črtež čerepa",
  "block.minecraft.banner.skull.purple": "Fioletovy črtež čerepa",
  "block.minecraft.banner.skull.red": "Črveny črtež čerepa",
  "block.minecraft.banner.skull.white": "Běly črtež čerepa",
  "block.minecraft.banner.skull.yellow": "Žolty črtež čerepa",
  "block.minecraft.banner.small_stripes.black": "Črne nevelike linije",
  "block.minecraft.banner.small_stripes.blue": "Modre nevelike linije",
  "block.minecraft.banner.small_stripes.brown": "Koričneve nevelike linije",
  "block.minecraft.banner.small_stripes.cyan": "Turkysove nevelike linije",
  "block.minecraft.banner.small_stripes.gray": "Sive nevelike linije",
  "block.minecraft.banner.small_stripes.green": "Zelene nevelike linije",
  "block.minecraft.banner.small_stripes.light_blue": "Světlomodre nevelike linije",
  "block.minecraft.banner.small_stripes.light_gray": "Jasnosive nevelike linije",
  "block.minecraft.banner.small_stripes.lime": "Jasnozelene nevelike linije",
  "block.minecraft.banner.small_stripes.magenta": "Purpurne nevelike linije",
  "block.minecraft.banner.small_stripes.orange": "Oranževe nevelike linije",
  "block.minecraft.banner.small_stripes.pink": "Rozove nevelike linije",
  "block.minecraft.banner.small_stripes.purple": "Fioletove nevelike linije",
  "block.minecraft.banner.small_stripes.red": "Črvene nevelike linije",
  "block.minecraft.banner.small_stripes.white": "Běle nevelike linije",
  "block.minecraft.banner.small_stripes.yellow": "Žolte nevelike linije",
  "block.minecraft.banner.square_bottom_left.black": "Črny dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.blue": "Modry dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.brown": "Koričnevy dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.cyan": "Turkysovy dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.gray": "Sivy dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.green": "Zeleny dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.light_blue": "Světlomodry dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.light_gray": "Jasnosivy dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.lime": "Jasnozeleny dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.magenta": "Purpurny dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.orange": "Oranževy dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.pink": "Rozovy dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.purple": "Fioletovy dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.red": "Črveny dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.white": "Běly dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_left.yellow": "Žolty dolny lěvy kvadrat",
  "block.minecraft.banner.square_bottom_right.black": "Črny dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.blue": "Modry dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.brown": "Koričnevy dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.cyan": "Turkysovy dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.gray": "Sivy dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.green": "Zeleny dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.light_blue": "Světlomodry dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.light_gray": "Jasnosivy dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.lime": "Jasnozeleny dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.magenta": "Purpurny dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.orange": "Oranževy dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.pink": "Rozovy dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.purple": "Fioletovy dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.red": "Črveny dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.white": "Běly dolny pravy kvadrat",
  "block.minecraft.banner.square_bottom_right.yellow": "Žolty dolny pravy kvadrat",
  "block.minecraft.banner.square_top_left.black": "Črny vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.blue": "Modry vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.brown": "Koričnevy vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.cyan": "Turkysovy vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.gray": "Sivy vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.green": "Zeleny vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.light_blue": "Světlomodry vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.light_gray": "Jasnosivy vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.lime": "Jasnozeleny vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.magenta": "Purpurny vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.orange": "Oranževy vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.pink": "Rozovy vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.purple": "Fioletovy vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.red": "Črveny vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.white": "Běly vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_left.yellow": "Žolty vrhny lěvy kvadrat",
  "block.minecraft.banner.square_top_right.black": "Črny vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.blue": "Modry vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.brown": "Koričnevy vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.cyan": "Turkysovy vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.gray": "Sivy vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.green": "Zeleny vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.light_blue": "Světlomodry vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.light_gray": "Jasnosivy vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.lime": "Jasnozeleny vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.magenta": "Purpurny vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.orange": "Oranževy vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.pink": "Rozovy vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.purple": "Fioletovy vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.red": "Črveny vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.white": "Běly vrhny pravy kvadrat",
  "block.minecraft.banner.square_top_right.yellow": "Žolty vrhny pravy kvadrat",
  "block.minecraft.banner.straight_cross.black": "Črny križ kvadratny",
  "block.minecraft.banner.straight_cross.blue": "Modry križ kvadratny",
  "block.minecraft.banner.straight_cross.brown": "Koričnevy križ kvadratny",
  "block.minecraft.banner.straight_cross.cyan": "Turkysovy križ kvadratny",
  "block.minecraft.banner.straight_cross.gray": "Sivy križ kvadratny",
  "block.minecraft.banner.straight_cross.green": "Zeleny križ kvadratny",
  "block.minecraft.banner.straight_cross.light_blue": "Světlomodry križ kvadratny",
  "block.minecraft.banner.straight_cross.light_gray": "Jasnosivy križ kvadratny",
  "block.minecraft.banner.straight_cross.lime": "Jasnozeleny križ kvadratny",
  "block.minecraft.banner.straight_cross.magenta": "Purpurny križ kvadratny",
  "block.minecraft.banner.straight_cross.orange": "Oranževy križ kvadratny",
  "block.minecraft.banner.straight_cross.pink": "Rozovy križ kvadratny",
  "block.minecraft.banner.straight_cross.purple": "Fioletovy križ kvadratny",
  "block.minecraft.banner.straight_cross.red": "Črveny križ kvadratny",
  "block.minecraft.banner.straight_cross.white": "Běly križ kvadratny",
  "block.minecraft.banner.straight_cross.yellow": "Žolty križ kvadratny",
  "block.minecraft.banner.stripe_bottom.black": "Črna dolna linija",
  "block.minecraft.banner.stripe_bottom.blue": "Modra dolna linija",
  "block.minecraft.banner.stripe_bottom.brown": "Koričneva dolna linija",
  "block.minecraft.banner.stripe_bottom.cyan": "Turkysova dolna linija",
  "block.minecraft.banner.stripe_bottom.gray": "Siva dolna linija",
  "block.minecraft.banner.stripe_bottom.green": "Zelena dolna linija",
  "block.minecraft.banner.stripe_bottom.light_blue": "Světlomodra dolna linija",
  "block.minecraft.banner.stripe_bottom.light_gray": "Jasnosiva dolna linija",
  "block.minecraft.banner.stripe_bottom.lime": "Jasnozelena dolna linija",
  "block.minecraft.banner.stripe_bottom.magenta": "Purpurna dolna linija",
  "block.minecraft.banner.stripe_bottom.orange": "Oranževa dolna linija",
  "block.minecraft.banner.stripe_bottom.pink": "Rozova dolna linija",
  "block.minecraft.banner.stripe_bottom.purple": "Fioletova dolna linija",
  "block.minecraft.banner.stripe_bottom.red": "Črvena dolna linija",
  "block.minecraft.banner.stripe_bottom.white": "Běla dolna linija",
  "block.minecraft.banner.stripe_bottom.yellow": "Žolta dolna linija",
  "block.minecraft.banner.stripe_center.black": "Črna srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.blue": "Modra srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.brown": "Koričneva srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.cyan": "Turkysova srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.gray": "Siva srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.green": "Zelena srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.light_blue": "Světlomodra srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.light_gray": "Jasnosiva srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.lime": "Jasnozelena srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.magenta": "Purpurna srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.orange": "Oranževa srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.pink": "Rozova srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.purple": "Fioletova srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.red": "Črvena srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.white": "Běla srědna linija vertikalna",
  "block.minecraft.banner.stripe_center.yellow": "Žolta srědna linija vertikalna",
  "block.minecraft.banner.stripe_downleft.black": "Črna dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.blue": "Modra dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.brown": "Koričneva dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.cyan": "Turkysova dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.gray": "Siva dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.green": "Zelena dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.light_blue": "Světlomodra dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.light_gray": "Jasnosiva dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.lime": "Jasnozelena dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.magenta": "Purpurna dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.orange": "Oranževa dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.pink": "Rozova dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.purple": "Fioletova dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.red": "Črvena dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.white": "Běla dolna lěva linija",
  "block.minecraft.banner.stripe_downleft.yellow": "Žolta dolna lěva linija",
  "block.minecraft.banner.stripe_downright.black": "Črna dolna prava linija",
  "block.minecraft.banner.stripe_downright.blue": "Modra dolna prava linija",
  "block.minecraft.banner.stripe_downright.brown": "Koričneva dolna prava linija",
  "block.minecraft.banner.stripe_downright.cyan": "Turkysova dolna prava linija",
  "block.minecraft.banner.stripe_downright.gray": "Siva dolna prava linija",
  "block.minecraft.banner.stripe_downright.green": "Zelena dolna prava linija",
  "block.minecraft.banner.stripe_downright.light_blue": "Světlomodra dolna prava linija",
  "block.minecraft.banner.stripe_downright.light_gray": "Jasnosiva dolna prava linija",
  "block.minecraft.banner.stripe_downright.lime": "Jasnozelena dolna prava linija",
  "block.minecraft.banner.stripe_downright.magenta": "Purpurna dolna prava linija",
  "block.minecraft.banner.stripe_downright.orange": "Oranževa dolna prava linija",
  "block.minecraft.banner.stripe_downright.pink": "Rozova dolna prava linija",
  "block.minecraft.banner.stripe_downright.purple": "Fioletova dolna prava linija",
  "block.minecraft.banner.stripe_downright.red": "Črvena dolna prava linija",
  "block.minecraft.banner.stripe_downright.white": "Běla dolna prava linija",
  "block.minecraft.banner.stripe_downright.yellow": "Žolta dolna prava linija",
  "block.minecraft.banner.stripe_left.black": "Črna lěva linija",
  "block.minecraft.banner.stripe_left.blue": "Modra lěva linija",
  "block.minecraft.banner.stripe_left.brown": "Koričneva lěva linija",
  "block.minecraft.banner.stripe_left.cyan": "Turkysova lěva linija",
  "block.minecraft.banner.stripe_left.gray": "Siva lěva linija",
  "block.minecraft.banner.stripe_left.green": "Zelena lěva linija",
  "block.minecraft.banner.stripe_left.light_blue": "Světlomodra lěva linija",
  "block.minecraft.banner.stripe_left.light_gray": "Jasnosiva lěva linija",
  "block.minecraft.banner.stripe_left.lime": "Jasnozelena lěva linija",
  "block.minecraft.banner.stripe_left.magenta": "Purpurna lěva linija",
  "block.minecraft.banner.stripe_left.orange": "Oranževa lěva linija",
  "block.minecraft.banner.stripe_left.pink": "Rozova lěva linija",
  "block.minecraft.banner.stripe_left.purple": "Fioletova lěva linija",
  "block.minecraft.banner.stripe_left.red": "Črvena lěva linija",
  "block.minecraft.banner.stripe_left.white": "Běla lěva linija",
  "block.minecraft.banner.stripe_left.yellow": "Žolta lěva linija",
  "block.minecraft.banner.stripe_middle.black": "Črna srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.blue": "Modra srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.brown": "Koričneva srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.cyan": "Turkysova srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.gray": "Siva srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.green": "Zelena srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.light_blue": "Světlomodra srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.light_gray": "Jasnosiva srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.lime": "Jasnozelena srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.magenta": "Purpurna srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.orange": "Oranževa srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.pink": "Rozova srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.purple": "Fioletova srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.red": "Črvena srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.white": "Běla srědna linija horizontalna",
  "block.minecraft.banner.stripe_middle.yellow": "Žolta srědna linija horizontalna",
  "block.minecraft.banner.stripe_right.black": "Črna prava linija",
  "block.minecraft.banner.stripe_right.blue": "Modra prava linija",
  "block.minecraft.banner.stripe_right.brown": "Koričneva prava linija",
  "block.minecraft.banner.stripe_right.cyan": "Turkysova prava linija",
  "block.minecraft.banner.stripe_right.gray": "Siva prava linija",
  "block.minecraft.banner.stripe_right.green": "Zelena prava linija",
  "block.minecraft.banner.stripe_right.light_blue": "Světlomodra prava linija",
  "block.minecraft.banner.stripe_right.light_gray": "Jasnosiva prava linija",
  "block.minecraft.banner.stripe_right.lime": "Jasnozelena prava linija",
  "block.minecraft.banner.stripe_right.magenta": "Purpurna prava linija",
  "block.minecraft.banner.stripe_right.orange": "Oranževa prava linija",
  "block.minecraft.banner.stripe_right.pink": "Rozova prava linija",
  "block.minecraft.banner.stripe_right.purple": "Fioletova prava linija",
  "block.minecraft.banner.stripe_right.red": "Črvena prava linija",
  "block.minecraft.banner.stripe_right.white": "Běla prava linija",
  "block.minecraft.banner.stripe_right.yellow": "Žolta prava linija",
  "block.minecraft.banner.stripe_top.black": "Črna vrhna linija",
  "block.minecraft.banner.stripe_top.blue": "Modra vrhna linija",
  "block.minecraft.banner.stripe_top.brown": "Koričneva vrhna linija",
  "block.minecraft.banner.stripe_top.cyan": "Turkysova vrhna linija",
  "block.minecraft.banner.stripe_top.gray": "Siva vrhna linija",
  "block.minecraft.banner.stripe_top.green": "Zelena vrhna linija",
  "block.minecraft.banner.stripe_top.light_blue": "Světlomodra vrhna linija",
  "block.minecraft.banner.stripe_top.light_gray": "Jasnosiva vrhna linija",
  "block.minecraft.banner.stripe_top.lime": "Jasnozelena vrhna linija",
  "block.minecraft.banner.stripe_top.magenta": "Purpurna vrhna linija",
  "block.minecraft.banner.stripe_top.orange": "Oranževa vrhna linija",
  "block.minecraft.banner.stripe_top.pink": "Rozova vrhna linija",
  "block.minecraft.banner.stripe_top.purple": "Fioletova vrhna linija",
  "block.minecraft.banner.stripe_top.red": "Črvena vrhna linija",
  "block.minecraft.banner.stripe_top.white": "Běla vrhna linija",
  "block.minecraft.banner.stripe_top.yellow": "Žolta vrhna linija",
  "block.minecraft.banner.triangle_bottom.black": "Črny dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.blue": "Modry dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.brown": "Koričnevy dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.cyan": "Turkysovy dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.gray": "Sivy dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.green": "Zeleny dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.light_blue": "Světlomodry dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.light_gray": "Jasnosivy dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.lime": "Jasnozeleny dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.magenta": "Purpurny dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.orange": "Oranževy dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.pink": "Rozovy dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.purple": "Fioletovy dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.red": "Črveny dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.white": "Běly dolny trivugolnik",
  "block.minecraft.banner.triangle_bottom.yellow": "Žolty dolny trivugolnik",
  "block.minecraft.banner.triangle_top.black": "Črny vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.blue": "Modry vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.brown": "Koričnevy vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.cyan": "Turkysovy vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.gray": "Sivy vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.green": "Zeleny vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.light_blue": "Světlomodry vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.light_gray": "Jasnosivy vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.lime": "Jasnozeleny vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.magenta": "Purpurny vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.orange": "Oranževy vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.pink": "Rozovy vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.purple": "Fioletovy vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.red": "Črveny vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.white": "Běly vrhny trivugolnik",
  "block.minecraft.banner.triangle_top.yellow": "Žolty vrhny trivugolnik",
  "block.minecraft.banner.triangles_bottom.black": "Črna dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.blue": "Modra dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.brown": "Koričneva dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.cyan": "Turkysova dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.gray": "Siva dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.green": "Zelena dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.light_blue": "Světlomodra dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.light_gray": "Jasnosiva dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.lime": "Jasnozelena dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.magenta": "Purpurna dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.orange": "Oranževa dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.pink": "Rozova dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.purple": "Fioletova dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.red": "Črvena dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.white": "Běla dolna linija s odstupom",
  "block.minecraft.banner.triangles_bottom.yellow": "Žolta dolna linija s odstupom",
  "block.minecraft.banner.triangles_top.black": "Črna vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.blue": "Modra vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.brown": "Koričneva vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.cyan": "Turkysova vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.gray": "Siva vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.green": "Zelena vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.light_blue": "Světlomodra vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.light_gray": "Jasnosiva vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.lime": "Jasnozelena vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.magenta": "Purpurna vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.orange": "Oranževa vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.pink": "Rozova vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.purple": "Fioletova vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.red": "Črvena vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.white": "Běla vrhna linija s odstupom",
  "block.minecraft.banner.triangles_top.yellow": "Žolta vrhna linija s odstupom",
  "block.minecraft.barrel": "Bočka",
  "block.minecraft.barrier": "Bariera",
  "block.minecraft.basalt": "Bazalt",
  "block.minecraft.beacon": "Světilnik",
  "block.minecraft.beacon.primary": "Moč primarna",
  "block.minecraft.beacon.secondary": "Moč drugoredna",
  "block.minecraft.bed.no_sleep": "Vy možete spati jedino nočeju abo pri burjah",
  "block.minecraft.bed.not_safe": "Ne možeš nyně odpočivati, pobližno sut čudovišča",
  "block.minecraft.bed.obstructed": "To ležišče jest zastavjeno",
  "block.minecraft.bed.occupied": "To ležišče jest zajeto",
  "block.minecraft.bed.too_far_away": "Ne možeš nyně odpočivati, ležišče prědaleko",
  "block.minecraft.bedrock": "Nedobry kamenj",
  "block.minecraft.bee_nest": "Brt",
  "block.minecraft.beehive": "Ulja",
  "block.minecraft.beetroots": "Cvekly",
  "block.minecraft.bell": "Zvon",
  "block.minecraft.big_dripleaf": "Veliky kapjelist",
  "block.minecraft.big_dripleaf_stem": "Steblo velikogo kapjelista",
  "block.minecraft.birch_button": "Brězova knopka",
  "block.minecraft.birch_door": "Brězove dveri",
  "block.minecraft.birch_fence": "Brězova ograda",
  "block.minecraft.birch_fence_gate": "Brězove vrata",
  "block.minecraft.birch_hanging_sign": "Pověšena brězova vyvěska",
  "block.minecraft.birch_leaves": "Brězove listy",
  "block.minecraft.birch_log": "Brězova klada",
  "block.minecraft.birch_planks": "Brězove dosky",
  "block.minecraft.birch_pressure_plate": "Brězovy pritiskany platform",
  "block.minecraft.birch_sapling": "Brězovy rastok",
  "block.minecraft.birch_shelf": "Brězova polica",
  "block.minecraft.birch_sign": "Brězova vyvěska",
  "block.minecraft.birch_slab": "Brězovy platform",
  "block.minecraft.birch_stairs": "Brězove stupenišče",
  "block.minecraft.birch_trapdoor": "Brězovy otvor",
  "block.minecraft.birch_wall_hanging_sign": "Nastěnna pověšena brězova vyvěska",
  "block.minecraft.birch_wall_sign": "Nastěnna brězova vyvěska",
  "block.minecraft.birch_wood": "Brězovo drěvo",
  "block.minecraft.black_banner": "Črna horugva",
  "block.minecraft.black_bed": "Črno ležišče",
  "block.minecraft.black_candle": "Črna svěča",
  "block.minecraft.black_candle_cake": "Tort s črnoju svěčeju",
  "block.minecraft.black_carpet": "Črny koverec",
  "block.minecraft.black_concrete": "Črny beton",
  "block.minecraft.black_concrete_powder": "Črny cement",
  "block.minecraft.black_glazed_terracotta": "Črna glazovana terakota",
  "block.minecraft.black_shulker_box": "Črna šalkerova krabka",
  "block.minecraft.black_stained_glass": "Črno steklo",
  "block.minecraft.black_stained_glass_pane": "Črny steklěny panel",
  "block.minecraft.black_terracotta": "Črna terakota",
  "block.minecraft.black_wool": "Črna volna",
  "block.minecraft.blackstone": "Črnit",
  "block.minecraft.blackstone_slab": "Črnitovy platform",
  "block.minecraft.blackstone_stairs": "Črnitove stupenišče",
  "block.minecraft.blackstone_wall": "Črnitova stěna",
  "block.minecraft.blast_furnace": "Goreči peč",
  "block.minecraft.blue_banner": "Modra horugva",
  "block.minecraft.blue_bed": "Modro ležišče",
  "block.minecraft.blue_candle": "Modra svěča",
  "block.minecraft.blue_candle_cake": "Tort s modroju svěčeju",
  "block.minecraft.blue_carpet": "Modry koverec",
  "block.minecraft.blue_concrete": "Modry beton",
  "block.minecraft.blue_concrete_powder": "Modry cement",
  "block.minecraft.blue_glazed_terracotta": "Modra glazovana terakota",
  "block.minecraft.blue_ice": "Modry led",
  "block.minecraft.blue_orchid": "Modra orhideja",
  "block.minecraft.blue_shulker_box": "Modra šalkerova skrinja",
  "block.minecraft.blue_stained_glass": "Modro steklo",
  "block.minecraft.blue_stained_glass_pane": "Modry steklěny panel",
  "block.minecraft.blue_terracotta": "Modra terakota",
  "block.minecraft.blue_wool": "Modra volna",
  "block.minecraft.bone_block": "Blok kosti",
  "block.minecraft.bookshelf": "Polica na knigy",
  "block.minecraft.brain_coral": "Mozgovy koral",
  "block.minecraft.brain_coral_block": "Blok mozgovogo korala",
  "block.minecraft.brain_coral_fan": "Vějarny mozgovy koral",
  "block.minecraft.brain_coral_wall_fan": "Stěnovy Mozgovy Vějarovy Koral",
  "block.minecraft.brewing_stand": "Napitnik",
  "block.minecraft.brick_slab": "Cegleny platform",
  "block.minecraft.brick_stairs": "Ceglene stupenišče",
  "block.minecraft.brick_wall": "Ceglena stěna",
  "block.minecraft.bricks": "Cegly",
  "block.minecraft.brown_banner": "Koričneva horugva",
  "block.minecraft.brown_bed": "Koričnevo ležišče",
  "block.minecraft.brown_candle": "Koričneva svěča",
  "block.minecraft.brown_candle_cake": "Tort s koričnevoju svěčeju",
  "block.minecraft.brown_carpet": "Koričnevy koverec",
  "block.minecraft.brown_concrete": "Koričnevy beton",
  "block.minecraft.brown_concrete_powder": "Koričnevy cement",
  "block.minecraft.brown_glazed_terracotta": "Koričneva glazovana terakota",
  "block.minecraft.brown_mushroom": "Borovik",
  "block.minecraft.brown_mushroom_block": "Blok borovika",
  "block.minecraft.brown_shulker_box": "Koričneva šalkerova krabka",
  "block.minecraft.brown_stained_glass": "Koričnevo steklo",
  "block.minecraft.brown_stained_glass_pane": "Koričnevy steklěny panel",
  "block.minecraft.brown_terracotta": "Koričneva terakota",
  "block.minecraft.brown_wool": "Koričneva volna",
  "block.minecraft.bubble_column": "Kolona bublin",
  "block.minecraft.bubble_coral": "Bublinovy koral",
  "block.minecraft.bubble_coral_block": "Blok puhyrčatogo korala",
  "block.minecraft.bubble_coral_fan": "Vějarny bublinovy koral",
  "block.minecraft.bubble_coral_wall_fan": "Stěnovy Bublinovy Vjarovy Koral",
  "block.minecraft.budding_amethyst": "Cvětuči ametist",
  "block.minecraft.bush": "Kust",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Cvět kaktusa",
  "block.minecraft.cake": "Tort",
  "block.minecraft.calcite": "Kalcit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibrovany skuljnik",
  "block.minecraft.campfire": "Taborny ogonj",
  "block.minecraft.candle": "Svěča",
  "block.minecraft.candle_cake": "Tort so svěčeju",
  "block.minecraft.carrots": "Mrkvy",
  "block.minecraft.cartography_table": "Kartografičny stol",
  "block.minecraft.carved_pumpkin": "Izrězana tykva",
  "block.minecraft.cauldron": "Kotel",
  "block.minecraft.cave_air": "Jamovy vozduh",
  "block.minecraft.cave_vines": "Jamove polzavice",
  "block.minecraft.cave_vines_plant": "Rastlina jamnoj lozy",
  "block.minecraft.chain": "Lancuh",
  "block.minecraft.chain_command_block": "Poslědovateljny blok prikazov",
  "block.minecraft.cherry_button": "Višnjeva knopka",
  "block.minecraft.cherry_door": "Višnjeve dveri",
  "block.minecraft.cherry_fence": "Višnjeva ograda",
  "block.minecraft.cherry_fence_gate": "Višnjeve vrata",
  "block.minecraft.cherry_hanging_sign": "Pověšena višnjeva vyvěska",
  "block.minecraft.cherry_leaves": "Višnjeve listy",
  "block.minecraft.cherry_log": "Višnjeva klada",
  "block.minecraft.cherry_planks": "Višnjeve dosky",
  "block.minecraft.cherry_pressure_plate": "Višnjevy pritiskany platform",
  "block.minecraft.cherry_sapling": "Višnjevy rastok",
  "block.minecraft.cherry_shelf": "Višnjeva polica",
  "block.minecraft.cherry_sign": "Višnjeva vyvěska",
  "block.minecraft.cherry_slab": "Višnjevy platform",
  "block.minecraft.cherry_stairs": "Višnjeve stupenišče",
  "block.minecraft.cherry_trapdoor": "Višnjevy otvor",
  "block.minecraft.cherry_wall_hanging_sign": "Nastěnna pověšena višnjeva vyvěska",
  "block.minecraft.cherry_wall_sign": "Nastěnna višnjeva vyvěska",
  "block.minecraft.cherry_wood": "Višnjevo drěvo",
  "block.minecraft.chest": "Skrinja",
  "block.minecraft.chipped_anvil": "Vyščrbena nakovaljnja",
  "block.minecraft.chiseled_bookshelf": "Vrubana polica na knigy",
  "block.minecraft.chiseled_copper": "Vrubany měd",
  "block.minecraft.chiseled_deepslate": "Vrubany glubinny skameněly plast",
  "block.minecraft.chiseled_nether_bricks": "Vrubane nezerove cegly",
  "block.minecraft.chiseled_polished_blackstone": "Vrubany polirany črnit",
  "block.minecraft.chiseled_quartz_block": "Vrubany blok kvarca",
  "block.minecraft.chiseled_red_sandstone": "Vrubany črveny pěsočny kamenj",
  "block.minecraft.chiseled_resin_bricks": "Vrubane smolove cegly",
  "block.minecraft.chiseled_sandstone": "Vrubany pěsočny kamenj",
  "block.minecraft.chiseled_stone_bricks": "Vrubane kamenne cegly",
  "block.minecraft.chiseled_tuff": "Vrubany tuf",
  "block.minecraft.chiseled_tuff_bricks": "Vrubane tufove cegly",
  "block.minecraft.chorus_flower": "Cvět horusa",
  "block.minecraft.chorus_plant": "Steblo horusa",
  "block.minecraft.clay": "Glina",
  "block.minecraft.closed_eyeblossom": "Zatvorjeny okocvět",
  "block.minecraft.coal_block": "Blok vugolja",
  "block.minecraft.coal_ore": "Vugoljna ruda",
  "block.minecraft.coarse_dirt": "Hrapava zemja",
  "block.minecraft.cobbled_deepslate": "Glubinny skameněly plast",
  "block.minecraft.cobbled_deepslate_slab": "Glubinny skameněly plastovy platform",
  "block.minecraft.cobbled_deepslate_stairs": "Glubinne skameněle plastove stupenišče",
  "block.minecraft.cobbled_deepslate_wall": "Glubinna skameněla plastova stěna",
  "block.minecraft.cobblestone": "Poděleny kamenj",
  "block.minecraft.cobblestone_slab": "Poděleny kamenny platform",
  "block.minecraft.cobblestone_stairs": "Podělene kamenne stupenišče",
  "block.minecraft.cobblestone_wall": "Podělena kamenna stěna",
  "block.minecraft.cobweb": "Pavučina",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Blok prikazov",
  "block.minecraft.comparator": "Redstounovy sravnjatel",
  "block.minecraft.composter": "Kompostnik",
  "block.minecraft.conduit": "Morska srdcevina",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Blok mědi",
  "block.minecraft.copper_bulb": "Mědna lukovica",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Mědna skrinja",
  "block.minecraft.copper_door": "Mědne dveri",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Mědny gril",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Mědna ruda",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Mědny otvor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Sinij vasiljok",
  "block.minecraft.cracked_deepslate_bricks": "Razdrobjene glubinne plastove cegly",
  "block.minecraft.cracked_deepslate_tiles": "Razdrobjeny glubinny plastovy parket",
  "block.minecraft.cracked_nether_bricks": "Razdrobjene nezerove cegly",
  "block.minecraft.cracked_polished_blackstone_bricks": "Razdrobjene polirane črnitove cegly",
  "block.minecraft.cracked_stone_bricks": "Razdrobjane kamenne cegly",
  "block.minecraft.crafter": "Tvoritelj",
  "block.minecraft.crafting_table": "Vrštat",
  "block.minecraft.creaking_heart": "Srdce trěsčnika",
  "block.minecraft.creeper_head": "Glava kripera",
  "block.minecraft.creeper_wall_head": "Nastěnna glava kripera",
  "block.minecraft.crimson_button": "Bagrova knopka",
  "block.minecraft.crimson_door": "Bagrove dveri",
  "block.minecraft.crimson_fence": "Bagrova ograda",
  "block.minecraft.crimson_fence_gate": "Bagrove vrata",
  "block.minecraft.crimson_fungus": "Bagrovy grib",
  "block.minecraft.crimson_hanging_sign": "Pověšena bagrova vyvěska",
  "block.minecraft.crimson_hyphae": "Bagrove hify",
  "block.minecraft.crimson_nylium": "Bagrova nezgribja",
  "block.minecraft.crimson_planks": "Bagrove dosky",
  "block.minecraft.crimson_pressure_plate": "Bagrovy pritiskany platform",
  "block.minecraft.crimson_roots": "Bagrove korenje",
  "block.minecraft.crimson_shelf": "Bagrova polica",
  "block.minecraft.crimson_sign": "Bagrova vyvěska",
  "block.minecraft.crimson_slab": "Bagrovy platform",
  "block.minecraft.crimson_stairs": "Bagrove stupenišče",
  "block.minecraft.crimson_stem": "Bagrovo steblo",
  "block.minecraft.crimson_trapdoor": "Bagrovy otvor",
  "block.minecraft.crimson_wall_hanging_sign": "Nastěnna pověšena bagrova vyvěska",
  "block.minecraft.crimson_wall_sign": "Nastěnna bagrova vyvěska",
  "block.minecraft.crying_obsidian": "Plačajuči obsidian",
  "block.minecraft.cut_copper": "Pileny měd",
  "block.minecraft.cut_copper_slab": "Pileny mědny platform",
  "block.minecraft.cut_copper_stairs": "Pilene mědne stupenišče",
  "block.minecraft.cut_red_sandstone": "Pileny črveny pěsočny kamenj",
  "block.minecraft.cut_red_sandstone_slab": "Pileny črveny pěsočny kamenny platform",
  "block.minecraft.cut_sandstone": "Pileny pěsočny kamenj",
  "block.minecraft.cut_sandstone_slab": "Pileny pěsočny kamenny platform",
  "block.minecraft.cyan_banner": "Turkysova horugva",
  "block.minecraft.cyan_bed": "Turkysovo ležišče",
  "block.minecraft.cyan_candle": "Turkysova svěča",
  "block.minecraft.cyan_candle_cake": "Tort s turkysovoju svěčeju",
  "block.minecraft.cyan_carpet": "Turkysovy koverec",
  "block.minecraft.cyan_concrete": "Turkysovy beton",
  "block.minecraft.cyan_concrete_powder": "Turkysovy cement",
  "block.minecraft.cyan_glazed_terracotta": "Turkysova glazovana terakota",
  "block.minecraft.cyan_shulker_box": "Turkysova šalkerova krabka",
  "block.minecraft.cyan_stained_glass": "Turkysovo steklo",
  "block.minecraft.cyan_stained_glass_pane": "Turkysovy steklěny panel",
  "block.minecraft.cyan_terracotta": "Turkysova terakota",
  "block.minecraft.cyan_wool": "Turkysova volna",
  "block.minecraft.damaged_anvil": "Poškodžena nakovaljnja",
  "block.minecraft.dandelion": "Dmuhavec",
  "block.minecraft.dark_oak_button": "Mračnodubova knopka",
  "block.minecraft.dark_oak_door": "Mračnodubove dveri",
  "block.minecraft.dark_oak_fence": "Mračnodubova ograda",
  "block.minecraft.dark_oak_fence_gate": "Mračnodubove vrata",
  "block.minecraft.dark_oak_hanging_sign": "Pověšena mračnodubova vyvěska",
  "block.minecraft.dark_oak_leaves": "Mračnodubove listy",
  "block.minecraft.dark_oak_log": "Mračnodubova klada",
  "block.minecraft.dark_oak_planks": "Mračnodubove dosky",
  "block.minecraft.dark_oak_pressure_plate": "Mračnodubovy pritiskany platform",
  "block.minecraft.dark_oak_sapling": "Mračnodubovy rastok",
  "block.minecraft.dark_oak_shelf": "Mračnodubova polica",
  "block.minecraft.dark_oak_sign": "Mračnodubova vyvěska",
  "block.minecraft.dark_oak_slab": "Mračnodubovy platform",
  "block.minecraft.dark_oak_stairs": "Mračnodubove stupenišče",
  "block.minecraft.dark_oak_trapdoor": "Mračnodubovy otvor",
  "block.minecraft.dark_oak_wall_hanging_sign": "Nastěnna pověšena mračnodubova vyvěska",
  "block.minecraft.dark_oak_wall_sign": "Nastěnna mračnodubova vyvěska",
  "block.minecraft.dark_oak_wood": "Mračnodubovo drěvo",
  "block.minecraft.dark_prismarine": "Temnoprizmarin",
  "block.minecraft.dark_prismarine_slab": "Temnoprizmarinovy platform",
  "block.minecraft.dark_prismarine_stairs": "Temnoprizmarinove stupenišče",
  "block.minecraft.daylight_detector": "Senzor dennogo světla",
  "block.minecraft.dead_brain_coral": "Mrtvy mozgovy koral",
  "block.minecraft.dead_brain_coral_block": "Blok mrtvogo mozgovogo korala",
  "block.minecraft.dead_brain_coral_fan": "Mrtvy vějarny mozgovy koral",
  "block.minecraft.dead_brain_coral_wall_fan": "Mrtvy Vějarovy Mozgovy Stěnny Koral",
  "block.minecraft.dead_bubble_coral": "Mrtvy bublinovy koral",
  "block.minecraft.dead_bubble_coral_block": "Blok mrtvogo puhyrčatogo korala",
  "block.minecraft.dead_bubble_coral_fan": "Mtrvy vějarny bublinovy koral",
  "block.minecraft.dead_bubble_coral_wall_fan": "Mrtvy Vějarovy Bublinovy Stěnny Koral",
  "block.minecraft.dead_bush": "Suhy kust",
  "block.minecraft.dead_fire_coral": "Mrtvy ognjeny koral",
  "block.minecraft.dead_fire_coral_block": "Blok mrtvogo ognjenogo korala",
  "block.minecraft.dead_fire_coral_fan": "Mrtvy vějarny ognjeny koral",
  "block.minecraft.dead_fire_coral_wall_fan": "Mrtvy Vějarovy Žženy Stěnny Koral",
  "block.minecraft.dead_horn_coral": "Mrtvy rogovy koral",
  "block.minecraft.dead_horn_coral_block": "Blok mrtvogo rogovogo korala",
  "block.minecraft.dead_horn_coral_fan": "Mrtvy vějarny rogovy koral",
  "block.minecraft.dead_horn_coral_wall_fan": "Mrtvy Vějarovy Rogovy Stěnny Koral",
  "block.minecraft.dead_tube_coral": "Mrtvy trubčaty koral",
  "block.minecraft.dead_tube_coral_block": "Blok mrtvogo trubčatogo korala",
  "block.minecraft.dead_tube_coral_fan": "Mrtvy vějarny trubčaty koral",
  "block.minecraft.dead_tube_coral_wall_fan": "Mrtvy Vějarovy Trubovy Stěnny Koral",
  "block.minecraft.decorated_pot": "Ozdobjeny grn",
  "block.minecraft.deepslate": "Glubinny plast",
  "block.minecraft.deepslate_brick_slab": "Glubinny plastovy platform",
  "block.minecraft.deepslate_brick_stairs": "Glubinne plastove ceglene stupenišče",
  "block.minecraft.deepslate_brick_wall": "Glubinna plastova ceglena stěna",
  "block.minecraft.deepslate_bricks": "Glubinne plastove cegly",
  "block.minecraft.deepslate_coal_ore": "Gluboka vugoljna ruda",
  "block.minecraft.deepslate_copper_ore": "Gluboka mědna ruda",
  "block.minecraft.deepslate_diamond_ore": "Gluboka diamantova ruda",
  "block.minecraft.deepslate_emerald_ore": "Gluboka smaragdova ruda",
  "block.minecraft.deepslate_gold_ore": "Gluboka zlata ruda",
  "block.minecraft.deepslate_iron_ore": "Gluboka želězna ruda",
  "block.minecraft.deepslate_lapis_ore": "Gluboka lazulitova ruda",
  "block.minecraft.deepslate_redstone_ore": "Gluboka redstounova ruda",
  "block.minecraft.deepslate_tile_slab": "Glubinny plastovy parketny platform",
  "block.minecraft.deepslate_tile_stairs": "Glubinne plastove parketne stupenišče",
  "block.minecraft.deepslate_tile_wall": "Glubinna plastova parketna stěna",
  "block.minecraft.deepslate_tiles": "Glubinny plastovy parket",
  "block.minecraft.detector_rail": "Senzorova kolěja",
  "block.minecraft.diamond_block": "Blok diamanta",
  "block.minecraft.diamond_ore": "Diamantova ruda",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritovy platform",
  "block.minecraft.diorite_stairs": "Dioritove stupenišče",
  "block.minecraft.diorite_wall": "Dioritova stěna",
  "block.minecraft.dirt": "Zemja",
  "block.minecraft.dirt_path": "Stežka zemji",
  "block.minecraft.dispenser": "Izkydatnik",
  "block.minecraft.dragon_egg": "Jajce drakona",
  "block.minecraft.dragon_head": "Glava drakona",
  "block.minecraft.dragon_wall_head": "Nastěnna glava drakona",
  "block.minecraft.dried_ghast": "Izsohnuvši gast",
  "block.minecraft.dried_kelp_block": "Blok suhovodorastov",
  "block.minecraft.dripstone_block": "Blok kapnika",
  "block.minecraft.dropper": "Izdavač",
  "block.minecraft.emerald_block": "Blok smaragda",
  "block.minecraft.emerald_ore": "Smaragdova ruda",
  "block.minecraft.enchanting_table": "Čarovny stol",
  "block.minecraft.end_gateway": "Vrata Enda",
  "block.minecraft.end_portal": "Portal endu",
  "block.minecraft.end_portal_frame": "Rama prohodu v Endu",
  "block.minecraft.end_rod": "Endova rozga",
  "block.minecraft.end_stone": "Kamenj Enda",
  "block.minecraft.end_stone_brick_slab": "Kamenny cegleny platform enda",
  "block.minecraft.end_stone_brick_stairs": "Kamenne ceglene stupenišče enda",
  "block.minecraft.end_stone_brick_wall": "Kamenne cegly enda enda",
  "block.minecraft.end_stone_bricks": "Kamenne cegly enda",
  "block.minecraft.ender_chest": "Skrinja endera",
  "block.minecraft.exposed_chiseled_copper": "Izstavjeny vrubany měd",
  "block.minecraft.exposed_copper": "Izstavjeny měd",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Izstavjena mědna lukovica",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Izstavjena mědna skrinja",
  "block.minecraft.exposed_copper_door": "Izstavjene mědne dveri",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Izstavjeny mědny gril",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Izstavjeny mědny otvor",
  "block.minecraft.exposed_cut_copper": "Izstavjeny pileny měd",
  "block.minecraft.exposed_cut_copper_slab": "Izstavjeny pileny mědny platform",
  "block.minecraft.exposed_cut_copper_stairs": "Izstavjene mědne stupenišče",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Oranica",
  "block.minecraft.fern": "Paprat",
  "block.minecraft.fire": "Ogonj",
  "block.minecraft.fire_coral": "Ognjeny koral",
  "block.minecraft.fire_coral_block": "Blok ognjenogo korala",
  "block.minecraft.fire_coral_fan": "Vějarny ognjeny koral",
  "block.minecraft.fire_coral_wall_fan": "Vějarny Žžemy Stěnny Koral",
  "block.minecraft.firefly_bush": "Kust so světluškami",
  "block.minecraft.fletching_table": "Stol do produkcije strěl",
  "block.minecraft.flower_pot": "Cvětny grn",
  "block.minecraft.flowering_azalea": "Cvětuča azalija",
  "block.minecraft.flowering_azalea_leaves": "Cvětuče listy azaliji",
  "block.minecraft.frogspawn": "Ikra žaby",
  "block.minecraft.frosted_ice": "Krěhky led",
  "block.minecraft.furnace": "Peč",
  "block.minecraft.gilded_blackstone": "Pozlačeny črnit",
  "block.minecraft.glass": "Steklo",
  "block.minecraft.glass_pane": "Steklěny panel",
  "block.minecraft.glow_lichen": "Světly lišaj",
  "block.minecraft.glowstone": "Světlokamenj",
  "block.minecraft.gold_block": "Blok zlata",
  "block.minecraft.gold_ore": "Zlata ruda",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitovy platform",
  "block.minecraft.granite_stairs": "Granitove stupenišče",
  "block.minecraft.granite_wall": "Granitova stěna",
  "block.minecraft.grass": "Trava",
  "block.minecraft.grass_block": "Blok travy",
  "block.minecraft.gravel": "Drobjenec",
  "block.minecraft.gray_banner": "Siva horugva",
  "block.minecraft.gray_bed": "Sivo ležišče",
  "block.minecraft.gray_candle": "Sěra svěča",
  "block.minecraft.gray_candle_cake": "Tort so sěroju svěčeju",
  "block.minecraft.gray_carpet": "Sivy koverec",
  "block.minecraft.gray_concrete": "Sivy beton",
  "block.minecraft.gray_concrete_powder": "Sivy cement",
  "block.minecraft.gray_glazed_terracotta": "Siva glazovana terakota",
  "block.minecraft.gray_shulker_box": "Siva šalkerova krabka",
  "block.minecraft.gray_stained_glass": "Sivo steklo",
  "block.minecraft.gray_stained_glass_pane": "Sivy steklěny panel",
  "block.minecraft.gray_terracotta": "Siva terakota",
  "block.minecraft.gray_wool": "Siva volna",
  "block.minecraft.green_banner": "Zelena horugva",
  "block.minecraft.green_bed": "Zeleno ležišče",
  "block.minecraft.green_candle": "Zelena svěča",
  "block.minecraft.green_candle_cake": "Tort so zelenoju svěčeju",
  "block.minecraft.green_carpet": "Zeleny koverec",
  "block.minecraft.green_concrete": "Zeleny beton",
  "block.minecraft.green_concrete_powder": "Zeleny cement",
  "block.minecraft.green_glazed_terracotta": "Zelena glazovana terakota",
  "block.minecraft.green_shulker_box": "Zelena šalkerova krabka",
  "block.minecraft.green_stained_glass": "Zeleno steklo",
  "block.minecraft.green_stained_glass_pane": "Zeleny steklěny panel",
  "block.minecraft.green_terracotta": "Zelena terakota",
  "block.minecraft.green_wool": "Zelena volna",
  "block.minecraft.grindstone": "Brus",
  "block.minecraft.hanging_roots": "Věšene korenje",
  "block.minecraft.hay_block": "Bala sěna",
  "block.minecraft.heavy_core": "Težko jedro",
  "block.minecraft.heavy_weighted_pressure_plate": "Težky pritiskany platform",
  "block.minecraft.honey_block": "Medovy blok",
  "block.minecraft.honeycomb_block": "Sotovny blok",
  "block.minecraft.hopper": "Nasypnik",
  "block.minecraft.horn_coral": "Rogovy koral",
  "block.minecraft.horn_coral_block": "Blok rogovogo korala",
  "block.minecraft.horn_coral_fan": "Vějarny rogovy koral",
  "block.minecraft.horn_coral_wall_fan": "Vějarovy Rogovy Stěnny Koral",
  "block.minecraft.ice": "Led",
  "block.minecraft.infested_chiseled_stone_bricks": "Zaražane polirane kamenne cegly",
  "block.minecraft.infested_cobblestone": "Zaražany poděleny kamenj",
  "block.minecraft.infested_cracked_stone_bricks": "Zaražane razdrobjane kamenne cegly",
  "block.minecraft.infested_deepslate": "Zaraženy glubinny plast",
  "block.minecraft.infested_mossy_stone_bricks": "Zaražane travne kamenne cegly",
  "block.minecraft.infested_stone": "Zaražany kamenj",
  "block.minecraft.infested_stone_bricks": "Zaražane kamenne cegly",
  "block.minecraft.iron_bars": "Želězne pruty",
  "block.minecraft.iron_block": "Blok želěza",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Želězne dveri",
  "block.minecraft.iron_ore": "Želězna ruda",
  "block.minecraft.iron_trapdoor": "Želězny otvor",
  "block.minecraft.jack_o_lantern": "Tykvova světilka",
  "block.minecraft.jigsaw": "Vezatnik",
  "block.minecraft.jukebox": "Igrajuča skrinja",
  "block.minecraft.jungle_button": "Džunglova knopka",
  "block.minecraft.jungle_door": "Džunglove dveri",
  "block.minecraft.jungle_fence": "Džunglova ograda",
  "block.minecraft.jungle_fence_gate": "Džunglove vrata",
  "block.minecraft.jungle_hanging_sign": "Pověšena džunglova vyvěska",
  "block.minecraft.jungle_leaves": "Džunglove listy",
  "block.minecraft.jungle_log": "Džunglova klada",
  "block.minecraft.jungle_planks": "Džunglove dosky",
  "block.minecraft.jungle_pressure_plate": "Džunglovy pritiskany platform",
  "block.minecraft.jungle_sapling": "Džunglovy rastok",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Džunglova vyvěska",
  "block.minecraft.jungle_slab": "Džunglovy platform",
  "block.minecraft.jungle_stairs": "Džunglove stupenišče",
  "block.minecraft.jungle_trapdoor": "Džunglovy otvor",
  "block.minecraft.jungle_wall_hanging_sign": "Nastěnna pověšena džunglova vyvěska",
  "block.minecraft.jungle_wall_sign": "Nastěnna džunglova vyvěska",
  "block.minecraft.jungle_wood": "Džunglovo drěvo",
  "block.minecraft.kelp": "Vodorast",
  "block.minecraft.kelp_plant": "Rastuči vodorasty",
  "block.minecraft.ladder": "Drabina",
  "block.minecraft.lantern": "Světilka",
  "block.minecraft.lapis_block": "Blok lazurita",
  "block.minecraft.lapis_ore": "Lazuritova ruda",
  "block.minecraft.large_amethyst_bud": "Veliky zarodok ametista",
  "block.minecraft.large_fern": "Velika paprat",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Kotel s lavoju",
  "block.minecraft.leaf_litter": "Suhe listy",
  "block.minecraft.lectern": "Pult",
  "block.minecraft.lever": "Držka",
  "block.minecraft.light": "Světlo",
  "block.minecraft.light_blue_banner": "Světlomodra horugva",
  "block.minecraft.light_blue_bed": "Světlomodro ležišče",
  "block.minecraft.light_blue_candle": "Světlomodra svěča",
  "block.minecraft.light_blue_candle_cake": "Tort so světlomodroju svěčeju",
  "block.minecraft.light_blue_carpet": "Světlomodry koverec",
  "block.minecraft.light_blue_concrete": "Světlomodry beton",
  "block.minecraft.light_blue_concrete_powder": "Světlomodry cement",
  "block.minecraft.light_blue_glazed_terracotta": "Světlomodra glazovana terakota",
  "block.minecraft.light_blue_shulker_box": "Světlomodra šalkerova skrinja",
  "block.minecraft.light_blue_stained_glass": "Světlomodro steklo",
  "block.minecraft.light_blue_stained_glass_pane": "Světlomodry steklěny panel",
  "block.minecraft.light_blue_terracotta": "Světlomodra terakota",
  "block.minecraft.light_blue_wool": "Světlomodra volna",
  "block.minecraft.light_gray_banner": "Jasnosiva horugva",
  "block.minecraft.light_gray_bed": "Jasnosivo ležišče",
  "block.minecraft.light_gray_candle": "Světlosěra svěča",
  "block.minecraft.light_gray_candle_cake": "Tort so světlosěroju svěčeju",
  "block.minecraft.light_gray_carpet": "Jasnosivy koverec",
  "block.minecraft.light_gray_concrete": "Jasnosivy beton",
  "block.minecraft.light_gray_concrete_powder": "Jasnosivy cement",
  "block.minecraft.light_gray_glazed_terracotta": "Jasnosiva glazovana terakota",
  "block.minecraft.light_gray_shulker_box": "Jasnosiva šalkerova krabka",
  "block.minecraft.light_gray_stained_glass": "Jasnosivo steklo",
  "block.minecraft.light_gray_stained_glass_pane": "Jasnosivy steklěny panel",
  "block.minecraft.light_gray_terracotta": "Jasnosiva terakota",
  "block.minecraft.light_gray_wool": "Jasnosiva volna",
  "block.minecraft.light_weighted_pressure_plate": "Legky pritiskany platform",
  "block.minecraft.lightning_rod": "Rozga na blěskavice",
  "block.minecraft.lilac": "Boz",
  "block.minecraft.lily_of_the_valley": "Landiš",
  "block.minecraft.lily_pad": "Lekvanj",
  "block.minecraft.lime_banner": "Jasnozelena horugva",
  "block.minecraft.lime_bed": "Jasnozeleno ležišče",
  "block.minecraft.lime_candle": "Světlozelena svěča",
  "block.minecraft.lime_candle_cake": "Tort so světlozelenoju svěčeju",
  "block.minecraft.lime_carpet": "Jasnozeleny koverec",
  "block.minecraft.lime_concrete": "Jasnozeleny beton",
  "block.minecraft.lime_concrete_powder": "Jasnozeleny cement",
  "block.minecraft.lime_glazed_terracotta": "Jasnozelena glazovana terakota",
  "block.minecraft.lime_shulker_box": "Jasnozelena šalkerova krabka",
  "block.minecraft.lime_stained_glass": "Jasnozeleno steklo",
  "block.minecraft.lime_stained_glass_pane": "Jasnozeleny steklěny panel",
  "block.minecraft.lime_terracotta": "Jasnozelena terakota",
  "block.minecraft.lime_wool": "Světlozelena volna",
  "block.minecraft.lodestone": "Magnetit",
  "block.minecraft.loom": "Stanok",
  "block.minecraft.magenta_banner": "Purpurna horugva",
  "block.minecraft.magenta_bed": "Purpurno ležišče",
  "block.minecraft.magenta_candle": "Purpurna svěča",
  "block.minecraft.magenta_candle_cake": "Tort s purpurnoju svěčeju",
  "block.minecraft.magenta_carpet": "Purpurny koverec",
  "block.minecraft.magenta_concrete": "Purpurny beton",
  "block.minecraft.magenta_concrete_powder": "Purpurny cement",
  "block.minecraft.magenta_glazed_terracotta": "Purpurna glazovana terakota",
  "block.minecraft.magenta_shulker_box": "Purpurna šalkerova krabka",
  "block.minecraft.magenta_stained_glass": "Purpurno steklo",
  "block.minecraft.magenta_stained_glass_pane": "Purpurny steklěny panel",
  "block.minecraft.magenta_terracotta": "Purpurna terakota",
  "block.minecraft.magenta_wool": "Purpurna volna",
  "block.minecraft.magma_block": "Blok magmy",
  "block.minecraft.mangrove_button": "Mangrova knopka",
  "block.minecraft.mangrove_door": "Mangrove dveri",
  "block.minecraft.mangrove_fence": "Mangrova ograda",
  "block.minecraft.mangrove_fence_gate": "Mangrove vrata",
  "block.minecraft.mangrove_hanging_sign": "Pověšena mangrova vyvěska",
  "block.minecraft.mangrove_leaves": "Mangrove listy",
  "block.minecraft.mangrove_log": "Mangrova klada",
  "block.minecraft.mangrove_planks": "Mangrove dosky",
  "block.minecraft.mangrove_pressure_plate": "Mangrovy pritiskany platform",
  "block.minecraft.mangrove_propagule": "Mangrovy propagul",
  "block.minecraft.mangrove_roots": "Mangrove korenje",
  "block.minecraft.mangrove_shelf": "Mangrova polica",
  "block.minecraft.mangrove_sign": "Mangrova vyvěska",
  "block.minecraft.mangrove_slab": "Mangrovy platform",
  "block.minecraft.mangrove_stairs": "Mangrove stupenišče",
  "block.minecraft.mangrove_trapdoor": "Mangrovy otvor",
  "block.minecraft.mangrove_wall_hanging_sign": "Nastěnna pověšena mangrova vyvěska",
  "block.minecraft.mangrove_wall_sign": "Nastěnna mangrova vyvěska",
  "block.minecraft.mangrove_wood": "Mangrovo drěvo",
  "block.minecraft.medium_amethyst_bud": "Srědny zarodok ametista",
  "block.minecraft.melon": "Dynja",
  "block.minecraft.melon_stem": "Steblo dynje",
  "block.minecraft.moss_block": "Blok mha",
  "block.minecraft.moss_carpet": "Travny koverec",
  "block.minecraft.mossy_cobblestone": "Travny poděleny kamenj",
  "block.minecraft.mossy_cobblestone_slab": "Travny poděleny kamenny platform",
  "block.minecraft.mossy_cobblestone_stairs": "Travne podělene kamenne stupenišče",
  "block.minecraft.mossy_cobblestone_wall": "Travna podělena kamenna stěna",
  "block.minecraft.mossy_stone_brick_slab": "Travny kamenny cegleny platform",
  "block.minecraft.mossy_stone_brick_stairs": "Travne kamenne ceglene stupenišče",
  "block.minecraft.mossy_stone_brick_wall": "Travna kamenna ceglena stěna",
  "block.minecraft.mossy_stone_bricks": "Travne kamenne cegly",
  "block.minecraft.moving_piston": "Dvigajuči poršenj",
  "block.minecraft.mud": "Grez",
  "block.minecraft.mud_brick_slab": "Grezovy cegleny platform",
  "block.minecraft.mud_brick_stairs": "Grezove ceglene stupenišče",
  "block.minecraft.mud_brick_wall": "Grezova ceglena stěna",
  "block.minecraft.mud_bricks": "Grezove cegly",
  "block.minecraft.muddy_mangrove_roots": "Grezove mangrove korenje",
  "block.minecraft.mushroom_stem": "Val griba",
  "block.minecraft.mycelium": "Podgribja",
  "block.minecraft.nether_brick_fence": "Nezerova ceglena ograda",
  "block.minecraft.nether_brick_slab": "Nezerovy cegleny platform",
  "block.minecraft.nether_brick_stairs": "Nezerove ceglene stupenišče",
  "block.minecraft.nether_brick_wall": "Nezerova stěna",
  "block.minecraft.nether_bricks": "Nezerove cegly",
  "block.minecraft.nether_gold_ore": "Zlata ruda nezera",
  "block.minecraft.nether_portal": "Prohod v Nezeru",
  "block.minecraft.nether_quartz_ore": "Kvarcova ruda",
  "block.minecraft.nether_sprouts": "Rastoky nezera",
  "block.minecraft.nether_wart": "Nezerova bradavica",
  "block.minecraft.nether_wart_block": "Bradavičny blok",
  "block.minecraft.netherite_block": "Blok nezerita",
  "block.minecraft.netherrack": "Nezerak",
  "block.minecraft.note_block": "Notny blok",
  "block.minecraft.oak_button": "Dubova knopka",
  "block.minecraft.oak_door": "Dubove dveri",
  "block.minecraft.oak_fence": "Dubova ograda",
  "block.minecraft.oak_fence_gate": "Dubove vrata",
  "block.minecraft.oak_hanging_sign": "Pověšena dubova vyvěska",
  "block.minecraft.oak_leaves": "Dubove listy",
  "block.minecraft.oak_log": "Dubova klada",
  "block.minecraft.oak_planks": "Dubove dosky",
  "block.minecraft.oak_pressure_plate": "Dubovy pritiskany platform",
  "block.minecraft.oak_sapling": "Dubovy rastok",
  "block.minecraft.oak_shelf": "Dubova polica",
  "block.minecraft.oak_sign": "Dubova vyvěska",
  "block.minecraft.oak_slab": "Dubovy platform",
  "block.minecraft.oak_stairs": "Dubove stupenišče",
  "block.minecraft.oak_trapdoor": "Dubovy otvor",
  "block.minecraft.oak_wall_hanging_sign": "Nastěnna pověšena dubova vyvěska",
  "block.minecraft.oak_wall_sign": "Nastěnna dubova vyvěska",
  "block.minecraft.oak_wood": "Dubovo drěvo",
  "block.minecraft.observer": "Pogledatnik",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ohrovy světložab",
  "block.minecraft.ominous_banner": "Zlověstna horugva",
  "block.minecraft.open_eyeblossom": "Otvorjeny okocvět",
  "block.minecraft.orange_banner": "Oranževa horugva",
  "block.minecraft.orange_bed": "Oranževo ležišče",
  "block.minecraft.orange_candle": "Oranževa svěča",
  "block.minecraft.orange_candle_cake": "Tort s oranževoju svěčeju",
  "block.minecraft.orange_carpet": "Oranževy koverec",
  "block.minecraft.orange_concrete": "Oranževy beton",
  "block.minecraft.orange_concrete_powder": "Oranževy cement",
  "block.minecraft.orange_glazed_terracotta": "Oranževa glazovana terakota",
  "block.minecraft.orange_shulker_box": "Oranževa šalkerova krabka",
  "block.minecraft.orange_stained_glass": "Oranževo steklo",
  "block.minecraft.orange_stained_glass_pane": "Oranževy steklěny panel",
  "block.minecraft.orange_terracotta": "Oranževa terakota",
  "block.minecraft.orange_tulip": "Oranževy tulipan",
  "block.minecraft.orange_wool": "Oranževa volna",
  "block.minecraft.oxeye_daisy": "Romaška",
  "block.minecraft.oxidized_chiseled_copper": "Oksidny vrubany měd",
  "block.minecraft.oxidized_copper": "Oksidny měd",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oksidna mědna lukovica",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oksidna mědna skrinja",
  "block.minecraft.oxidized_copper_door": "Oksidne mědne dveri",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oksidny mědny gril",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oksidny mědny otvor",
  "block.minecraft.oxidized_cut_copper": "Oksidny pileny měd",
  "block.minecraft.oxidized_cut_copper_slab": "Oksidny pileny mědny platform",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksidno pileno mědno stupenišče",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Izbity led",
  "block.minecraft.packed_mud": "Gusta grez",
  "block.minecraft.pale_hanging_moss": "Blědy viseči moh",
  "block.minecraft.pale_moss_block": "Blědy Blok Mha",
  "block.minecraft.pale_moss_carpet": "Blědy Koverec Iz Mha",
  "block.minecraft.pale_oak_button": "Blědodubova knopka",
  "block.minecraft.pale_oak_door": "Blědodubove dveri",
  "block.minecraft.pale_oak_fence": "Blědodubova ograda",
  "block.minecraft.pale_oak_fence_gate": "Blědodubove vrata",
  "block.minecraft.pale_oak_hanging_sign": "Pověšena blědodubova vyvěska",
  "block.minecraft.pale_oak_leaves": "Blědodubove listy",
  "block.minecraft.pale_oak_log": "Blědodubova klada",
  "block.minecraft.pale_oak_planks": "Blědodubove dosky",
  "block.minecraft.pale_oak_pressure_plate": "Blědodubovy pritiskany platform",
  "block.minecraft.pale_oak_sapling": "Blědodubovy rastok",
  "block.minecraft.pale_oak_shelf": "Blědodubova polica",
  "block.minecraft.pale_oak_sign": "Blědodubova vyvěska",
  "block.minecraft.pale_oak_slab": "Blědodubovy platform",
  "block.minecraft.pale_oak_stairs": "Blědodubove stupenišče",
  "block.minecraft.pale_oak_trapdoor": "Blědodubovy otvor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Nastěnna pověšena blědodubova vyvěska",
  "block.minecraft.pale_oak_wall_sign": "Nastěnna blědodubova vyvěska",
  "block.minecraft.pale_oak_wood": "Blědodubovo drěvo",
  "block.minecraft.pearlescent_froglight": "Fioletovy světložab",
  "block.minecraft.peony": "Pivonja",
  "block.minecraft.petrified_oak_slab": "Skameněly dubovy platform",
  "block.minecraft.piglin_head": "Glava piglina",
  "block.minecraft.piglin_wall_head": "Svinja",
  "block.minecraft.pink_banner": "Rozova horugva",
  "block.minecraft.pink_bed": "Rozovo ležišče",
  "block.minecraft.pink_candle": "Rozova svěča",
  "block.minecraft.pink_candle_cake": "Tort s rozovoju svěčeju",
  "block.minecraft.pink_carpet": "Rozovy koverec",
  "block.minecraft.pink_concrete": "Rozovy beton",
  "block.minecraft.pink_concrete_powder": "Rozovy cement",
  "block.minecraft.pink_glazed_terracotta": "Rozova glazovana terakota",
  "block.minecraft.pink_petals": "Rozove listky",
  "block.minecraft.pink_shulker_box": "Rozova šalkerova krabka",
  "block.minecraft.pink_stained_glass": "Rozovo steklo",
  "block.minecraft.pink_stained_glass_pane": "Rozovy steklěny panel",
  "block.minecraft.pink_terracotta": "Rozova terakota",
  "block.minecraft.pink_tulip": "Rozovy tulipan",
  "block.minecraft.pink_wool": "Rozova volna",
  "block.minecraft.piston": "Poršenj",
  "block.minecraft.piston_head": "Glavica poršenja",
  "block.minecraft.pitcher_crop": "Kamenj",
  "block.minecraft.pitcher_plant": "Kamenja",
  "block.minecraft.player_head": "Glava igrača",
  "block.minecraft.player_head.named": "Glava igrača %s",
  "block.minecraft.player_wall_head": "Nastěnna glava igrača",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Ostry kapnik",
  "block.minecraft.polished_andesite": "Polirany andezit",
  "block.minecraft.polished_andesite_slab": "Polirany andezitovy platform",
  "block.minecraft.polished_andesite_stairs": "Polirane andezitove stupenišče",
  "block.minecraft.polished_basalt": "Polirany bazalt",
  "block.minecraft.polished_blackstone": "Polirany črnit",
  "block.minecraft.polished_blackstone_brick_slab": "Polirany črnitovy cegleny platform",
  "block.minecraft.polished_blackstone_brick_stairs": "Polirane črnitove ceglene stupenišče",
  "block.minecraft.polished_blackstone_brick_wall": "Polirana črnitova ceglena stěna",
  "block.minecraft.polished_blackstone_bricks": "Polirane črnitove cegly",
  "block.minecraft.polished_blackstone_button": "Polirana črnitova knopka",
  "block.minecraft.polished_blackstone_pressure_plate": "Polirany črnitovy pritiskany platform",
  "block.minecraft.polished_blackstone_slab": "Polirany črnitovy platform",
  "block.minecraft.polished_blackstone_stairs": "Polirane črnitove stupenišče",
  "block.minecraft.polished_blackstone_wall": "Polirana črnitova stěna",
  "block.minecraft.polished_deepslate": "Polirany glubinny plast",
  "block.minecraft.polished_deepslate_slab": "Polirany glubinny plastovy platform",
  "block.minecraft.polished_deepslate_stairs": "Polirane glubinne plastove stupenišče",
  "block.minecraft.polished_deepslate_wall": "Polirana glubinna plastova stěna",
  "block.minecraft.polished_diorite": "Polirany diorit",
  "block.minecraft.polished_diorite_slab": "Polirany dioritovy platform",
  "block.minecraft.polished_diorite_stairs": "Polirane dioritove stupenišče",
  "block.minecraft.polished_granite": "Polirany granit",
  "block.minecraft.polished_granite_slab": "Polirany granitovy platform",
  "block.minecraft.polished_granite_stairs": "Polirane granitove stupenišče",
  "block.minecraft.polished_tuff": "Polirany tuf",
  "block.minecraft.polished_tuff_slab": "Polirany tufovy platform",
  "block.minecraft.polished_tuff_stairs": "Polirane tufove stupenišče",
  "block.minecraft.polished_tuff_wall": "Polirana tufova stěna",
  "block.minecraft.poppy": "Mak",
  "block.minecraft.potatoes": "Kartoflje",
  "block.minecraft.potted_acacia_sapling": "Akacovy rastok v grnu",
  "block.minecraft.potted_allium": "Česnok v grnu",
  "block.minecraft.potted_azalea_bush": "Azalija v grnu",
  "block.minecraft.potted_azure_bluet": "Modra haustonja v grnu",
  "block.minecraft.potted_bamboo": "Bambus v grnu",
  "block.minecraft.potted_birch_sapling": "Brězovy rastok v grnu",
  "block.minecraft.potted_blue_orchid": "Modra orhideja v grnu",
  "block.minecraft.potted_brown_mushroom": "Borovik v grnu",
  "block.minecraft.potted_cactus": "Kaktus v grnu",
  "block.minecraft.potted_cherry_sapling": "Višnjevy rastok v grnu",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Sinij vasiljok v grnu",
  "block.minecraft.potted_crimson_fungus": "Bagrovy grib v grnu",
  "block.minecraft.potted_crimson_roots": "Bagrove korenje v grnu",
  "block.minecraft.potted_dandelion": "Dmuhavec v grnu",
  "block.minecraft.potted_dark_oak_sapling": "Mračnodubovy rastok v grnu",
  "block.minecraft.potted_dead_bush": "Suhy kust v grnu",
  "block.minecraft.potted_fern": "Paprat v grnu",
  "block.minecraft.potted_flowering_azalea_bush": "Cvětuča azalija v grnu",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Džunglovy rastok v grnu",
  "block.minecraft.potted_lily_of_the_valley": "Landiš v grnu",
  "block.minecraft.potted_mangrove_propagule": "Mangrovy propagul v grnu",
  "block.minecraft.potted_oak_sapling": "Dubovy rastok v grnu",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Oranževy tulipan v grnu",
  "block.minecraft.potted_oxeye_daisy": "Romaška v grnu",
  "block.minecraft.potted_pale_oak_sapling": "Blědodubovy rastok v grnu",
  "block.minecraft.potted_pink_tulip": "Rozovy tulipan v grnu",
  "block.minecraft.potted_poppy": "Mak v grnu",
  "block.minecraft.potted_red_mushroom": "Muhomor v grnu",
  "block.minecraft.potted_red_tulip": "Črveny tulipan v grnu",
  "block.minecraft.potted_spruce_sapling": "Smrěkovy rastok v grnu",
  "block.minecraft.potted_torchflower": "Vzvodna torča",
  "block.minecraft.potted_warped_fungus": "Izvračeny grib v grnu",
  "block.minecraft.potted_warped_roots": "Izvračene korenje v grnu",
  "block.minecraft.potted_white_tulip": "Běly tulipan v grnu",
  "block.minecraft.potted_wither_rose": "Roza vizera v grnu",
  "block.minecraft.powder_snow": "Prašek sněga",
  "block.minecraft.powder_snow_cauldron": "Kotel s prašnym sněgom",
  "block.minecraft.powered_rail": "Napajatna kolěja",
  "block.minecraft.prismarine": "Prizmarin",
  "block.minecraft.prismarine_brick_slab": "Prizmarinovy cegleny platform",
  "block.minecraft.prismarine_brick_stairs": "Prizmarinove ceglene stupenišče",
  "block.minecraft.prismarine_bricks": "Prizmarinove cegly",
  "block.minecraft.prismarine_slab": "Prizmarinovy platform",
  "block.minecraft.prismarine_stairs": "Prizmarinove stupenišče",
  "block.minecraft.prismarine_wall": "Prizmarinova stěna",
  "block.minecraft.pumpkin": "Tykva",
  "block.minecraft.pumpkin_stem": "Steblo tykvy",
  "block.minecraft.purple_banner": "Fioletova horugva",
  "block.minecraft.purple_bed": "Fioletovo ležišče",
  "block.minecraft.purple_candle": "Fioletova svěča",
  "block.minecraft.purple_candle_cake": "Tort s fioletovoju svěčeju",
  "block.minecraft.purple_carpet": "Fioletovy koverec",
  "block.minecraft.purple_concrete": "Fioletovy beton",
  "block.minecraft.purple_concrete_powder": "Fioletovy cement",
  "block.minecraft.purple_glazed_terracotta": "Fioletova glazovana terakota",
  "block.minecraft.purple_shulker_box": "Fioletova šalkerova krabka",
  "block.minecraft.purple_stained_glass": "Fioletovo steklo",
  "block.minecraft.purple_stained_glass_pane": "Fioletovy steklěny panel",
  "block.minecraft.purple_terracotta": "Fioletova terakota",
  "block.minecraft.purple_wool": "Fioletova volna",
  "block.minecraft.purpur_block": "Blok purpura",
  "block.minecraft.purpur_pillar": "Stolp purpura",
  "block.minecraft.purpur_slab": "Purpurovy platform",
  "block.minecraft.purpur_stairs": "Purpurove stupenišče",
  "block.minecraft.quartz_block": "Blok kvarca",
  "block.minecraft.quartz_bricks": "Kvarcove cegly",
  "block.minecraft.quartz_pillar": "Kvarcovy stolp",
  "block.minecraft.quartz_slab": "Kvarcovy platform",
  "block.minecraft.quartz_stairs": "Kvarcove stupenišče",
  "block.minecraft.rail": "Kolěja",
  "block.minecraft.raw_copper_block": "Blok surovoj mědi",
  "block.minecraft.raw_gold_block": "Blok surovogo zlata",
  "block.minecraft.raw_iron_block": "Blok surovogo želěza",
  "block.minecraft.red_banner": "Črvena horugva",
  "block.minecraft.red_bed": "Črveno ležišče",
  "block.minecraft.red_candle": "Črvena svěča",
  "block.minecraft.red_candle_cake": "Tort s črvenoju svěčeju",
  "block.minecraft.red_carpet": "Črveny koverec",
  "block.minecraft.red_concrete": "Črveny beton",
  "block.minecraft.red_concrete_powder": "Črveny cement",
  "block.minecraft.red_glazed_terracotta": "Črvena glazovana terakota",
  "block.minecraft.red_mushroom": "Muhomor",
  "block.minecraft.red_mushroom_block": "Blok muhomora",
  "block.minecraft.red_nether_brick_slab": "Črveny nezerovy platform",
  "block.minecraft.red_nether_brick_stairs": "Črvene nezerove stupenišče",
  "block.minecraft.red_nether_brick_wall": "Črvena nezerova stěna",
  "block.minecraft.red_nether_bricks": "Črvene nezerove cegly",
  "block.minecraft.red_sand": "Črveny pěsok",
  "block.minecraft.red_sandstone": "Črveny pěsočny kamenj",
  "block.minecraft.red_sandstone_slab": "Črveny pěsočny kamenny platform",
  "block.minecraft.red_sandstone_stairs": "Črvene pěsočne kamenne stupenišče",
  "block.minecraft.red_sandstone_wall": "Črvena pěsočna kamenna stěna",
  "block.minecraft.red_shulker_box": "Črvena šalkerova krabka",
  "block.minecraft.red_stained_glass": "Črveno steklo",
  "block.minecraft.red_stained_glass_pane": "Črveny steklěny panel",
  "block.minecraft.red_terracotta": "Črvena terakota",
  "block.minecraft.red_tulip": "Črveny tulipan",
  "block.minecraft.red_wool": "Črvena volna",
  "block.minecraft.redstone_block": "Blok redstouna",
  "block.minecraft.redstone_lamp": "Redstounova lampa",
  "block.minecraft.redstone_ore": "Redstounova ruda",
  "block.minecraft.redstone_torch": "Redstounova faklja",
  "block.minecraft.redstone_wall_torch": "Nastěnna redstounova faklja",
  "block.minecraft.redstone_wire": "Provod redstouna",
  "block.minecraft.reinforced_deepslate": "Usiljeny glubinny plast",
  "block.minecraft.repeater": "Redstounovy povtarjatel",
  "block.minecraft.repeating_command_block": "Povtarjajuči blok prikazov",
  "block.minecraft.resin_block": "Blok smoly",
  "block.minecraft.resin_brick_slab": "Smolovy cegleny platform",
  "block.minecraft.resin_brick_stairs": "Smolove ceglene stupenišče",
  "block.minecraft.resin_brick_wall": "Smolova stěna",
  "block.minecraft.resin_bricks": "Smolove cegly",
  "block.minecraft.resin_clump": "Gruda smoly",
  "block.minecraft.respawn_anchor": "Prěrodeča kotva",
  "block.minecraft.rooted_dirt": "Zakoreněla zemja",
  "block.minecraft.rose_bush": "Rozovy kust",
  "block.minecraft.sand": "Pěsok",
  "block.minecraft.sandstone": "Pěsočny kamenj",
  "block.minecraft.sandstone_slab": "Pěsočny kamenny platform",
  "block.minecraft.sandstone_stairs": "Pěsočne kamenne stupenišče",
  "block.minecraft.sandstone_wall": "Pěsočna kamenna stěna",
  "block.minecraft.scaffolding": "Fasadarja",
  "block.minecraft.sculk": "Skulk",
  "block.minecraft.sculk_catalyst": "Katalist skulka",
  "block.minecraft.sculk_sensor": "Senzor skulka",
  "block.minecraft.sculk_shrieker": "Skulk krik",
  "block.minecraft.sculk_vein": "Skulk žila",
  "block.minecraft.sea_lantern": "Morska světilka",
  "block.minecraft.sea_pickle": "Ognitelka",
  "block.minecraft.seagrass": "Morska trava",
  "block.minecraft.set_spawn": "Město prěrodženja je postavjano",
  "block.minecraft.short_dry_grass": "Kratka suha trava",
  "block.minecraft.short_grass": "Kratka trava",
  "block.minecraft.shroomlight": "Světlogrib",
  "block.minecraft.shulker_box": "Šalkerova krabka",
  "block.minecraft.skeleton_skull": "Čerep skeleta",
  "block.minecraft.skeleton_wall_skull": "Nastěnny čerep skeleta",
  "block.minecraft.slime_block": "Blok sliza",
  "block.minecraft.small_amethyst_bud": "Maly zarodok ametista",
  "block.minecraft.small_dripleaf": "Maly kapjelist",
  "block.minecraft.smithing_table": "Kovačsky stol",
  "block.minecraft.smoker": "Zapeč",
  "block.minecraft.smooth_basalt": "Gladky bazalt",
  "block.minecraft.smooth_quartz": "Gladky blok kvarca",
  "block.minecraft.smooth_quartz_slab": "Gladky kvarcovy platform",
  "block.minecraft.smooth_quartz_stairs": "Gladke kvarcove stupenišče",
  "block.minecraft.smooth_red_sandstone": "Gladky črveny pěsočny kamenj",
  "block.minecraft.smooth_red_sandstone_slab": "Gladky črveny pěsočny kamenny platform",
  "block.minecraft.smooth_red_sandstone_stairs": "Gladke črvene pěsočne kamenne stupenišče",
  "block.minecraft.smooth_sandstone": "Gladky pěsočny kamenj",
  "block.minecraft.smooth_sandstone_slab": "Gladky pěsočny kamenny platform",
  "block.minecraft.smooth_sandstone_stairs": "Gladke pěsočne kamenne stupenišče",
  "block.minecraft.smooth_stone": "Gladky kamenj",
  "block.minecraft.smooth_stone_slab": "Gladky kamenny platform",
  "block.minecraft.sniffer_egg": "Njuhačsko jajce",
  "block.minecraft.snow": "Sněg",
  "block.minecraft.snow_block": "Blok sněgu",
  "block.minecraft.soul_campfire": "Taborny ogonj duš",
  "block.minecraft.soul_fire": "Ogonj duš",
  "block.minecraft.soul_lantern": "Světilka duš",
  "block.minecraft.soul_sand": "Pěsok duš",
  "block.minecraft.soul_soil": "Zemja duš",
  "block.minecraft.soul_torch": "Faklja duš",
  "block.minecraft.soul_wall_torch": "Nastěnna faklja duš",
  "block.minecraft.spawn.not_valid": "Ne imaješ ni ležišča ni prěrodečej kotvy, abo one sut zastavjene",
  "block.minecraft.spawner": "Razsadnik čudovišč",
  "block.minecraft.spawner.desc1": "Interakcija s jajcem:",
  "block.minecraft.spawner.desc2": "Ustavja tip stvorjenja",
  "block.minecraft.sponge": "Guba",
  "block.minecraft.spore_blossom": "Sporocvět",
  "block.minecraft.spruce_button": "Smrěkova knopka",
  "block.minecraft.spruce_door": "Smrěkove dveri",
  "block.minecraft.spruce_fence": "Smrěkova ograda",
  "block.minecraft.spruce_fence_gate": "Smrěkove vrata",
  "block.minecraft.spruce_hanging_sign": "Pověšena smrěkova vyvěska",
  "block.minecraft.spruce_leaves": "Smrěkove listy",
  "block.minecraft.spruce_log": "Smrěkova klada",
  "block.minecraft.spruce_planks": "Smrěkove dosky",
  "block.minecraft.spruce_pressure_plate": "Smrěkovy pritiskany platform",
  "block.minecraft.spruce_sapling": "Smrěkovy rastok",
  "block.minecraft.spruce_shelf": "Smrěkova polica",
  "block.minecraft.spruce_sign": "Smrěkova vyvěska",
  "block.minecraft.spruce_slab": "Smrěkovy platform",
  "block.minecraft.spruce_stairs": "Smrěkove stupenišče",
  "block.minecraft.spruce_trapdoor": "Smrěkovy otvor",
  "block.minecraft.spruce_wall_hanging_sign": "Nastěnna pověšena smrěkova vyvěska",
  "block.minecraft.spruce_wall_sign": "Nastěnna smrěkova vyvěska",
  "block.minecraft.spruce_wood": "Smrěkovo drěvo",
  "block.minecraft.sticky_piston": "Lěpky poršenj",
  "block.minecraft.stone": "Kamenj",
  "block.minecraft.stone_brick_slab": "Kamenny cegleny platform",
  "block.minecraft.stone_brick_stairs": "Kamenne ceglene stupenišče",
  "block.minecraft.stone_brick_wall": "Kamenna ceglena stěna",
  "block.minecraft.stone_bricks": "Kamenne cegly",
  "block.minecraft.stone_button": "Kamenna knopka",
  "block.minecraft.stone_pressure_plate": "Kamenny pritiskany platform",
  "block.minecraft.stone_slab": "Kamenny platform",
  "block.minecraft.stone_stairs": "Kamenne stupenišče",
  "block.minecraft.stonecutter": "Kamenosěkator",
  "block.minecraft.stripped_acacia_log": "Tesana akacova klada",
  "block.minecraft.stripped_acacia_wood": "Tesano akacovo drěvo",
  "block.minecraft.stripped_bamboo_block": "Blok tesanogo bambusa",
  "block.minecraft.stripped_birch_log": "Tesana brězova klada",
  "block.minecraft.stripped_birch_wood": "Tesano brězovo drěvo",
  "block.minecraft.stripped_cherry_log": "Tesana višnjeva klada",
  "block.minecraft.stripped_cherry_wood": "Tesano višnjevo drěvo",
  "block.minecraft.stripped_crimson_hyphae": "Tesane bagrove hify",
  "block.minecraft.stripped_crimson_stem": "Tesano bagrovo steblo",
  "block.minecraft.stripped_dark_oak_log": "Tesana mračnodubova klada",
  "block.minecraft.stripped_dark_oak_wood": "Tesano mračnodubovo drěvo",
  "block.minecraft.stripped_jungle_log": "Tesana džunglova klada",
  "block.minecraft.stripped_jungle_wood": "Tesano džunglovo drěvo",
  "block.minecraft.stripped_mangrove_log": "Tesana mangrova klada",
  "block.minecraft.stripped_mangrove_wood": "Tesano mangrovo drěvo",
  "block.minecraft.stripped_oak_log": "Tesana dubova klada",
  "block.minecraft.stripped_oak_wood": "Tesano dubovo drěvo",
  "block.minecraft.stripped_pale_oak_log": "Tesana blědodubova klada",
  "block.minecraft.stripped_pale_oak_wood": "Tesane blědodubove drěvo",
  "block.minecraft.stripped_spruce_log": "Tesana smrěkova klada",
  "block.minecraft.stripped_spruce_wood": "Tesano smrěkovo drěvo",
  "block.minecraft.stripped_warped_hyphae": "Tesane izvračene hify",
  "block.minecraft.stripped_warped_stem": "Tesano izvračeno steblo",
  "block.minecraft.structure_block": "Blok struktur",
  "block.minecraft.structure_void": "Strukturna prazdnina",
  "block.minecraft.sugar_cane": "Cukrova trtina",
  "block.minecraft.sunflower": "Podsolnuh",
  "block.minecraft.suspicious_gravel": "Podzrěny drobjenec",
  "block.minecraft.suspicious_sand": "Podzrěny pěsok",
  "block.minecraft.sweet_berry_bush": "Kust sladkyh brusnic",
  "block.minecraft.tall_dry_grass": "Vysoka suha trava",
  "block.minecraft.tall_grass": "Vysoka trava",
  "block.minecraft.tall_seagrass": "Vysoka morska trava",
  "block.minecraft.target": "Cělj",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Testovy blok",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Temne steklo",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Faklja",
  "block.minecraft.torchflower": "Vzvodnik",
  "block.minecraft.torchflower_crop": "Torčeblna plodina",
  "block.minecraft.trapped_chest": "Past-skladišče",
  "block.minecraft.trial_spawner": "Izzovny razsadnik čudovišč",
  "block.minecraft.tripwire": "Provod",
  "block.minecraft.tripwire_hook": "Hak na provod",
  "block.minecraft.tube_coral": "Cěvkovy koral",
  "block.minecraft.tube_coral_block": "Blok trubčatogo korala",
  "block.minecraft.tube_coral_fan": "Vějarny trubčaty koral",
  "block.minecraft.tube_coral_wall_fan": "Stěnovy Vějarovy Cěvkovy Koral",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Tufovy cegleny platform",
  "block.minecraft.tuff_brick_stairs": "Tufove ceglene stupenišče",
  "block.minecraft.tuff_brick_wall": "Tufova ceglena stěna",
  "block.minecraft.tuff_bricks": "Tufove cegly",
  "block.minecraft.tuff_slab": "Tufovy platform",
  "block.minecraft.tuff_stairs": "Tufove stupenišče",
  "block.minecraft.tuff_wall": "Tufova stěna",
  "block.minecraft.turtle_egg": "Jajce žolva",
  "block.minecraft.twisting_vines": "Vijuče polzavice",
  "block.minecraft.twisting_vines_plant": "Rastuče vijuče polzavice",
  "block.minecraft.vault": "Skarbnica",
  "block.minecraft.verdant_froglight": "Zeleny světložab",
  "block.minecraft.vine": "Polzavice",
  "block.minecraft.void_air": "Prazdninovy vozduh",
  "block.minecraft.wall_torch": "Nastěnna faklja",
  "block.minecraft.warped_button": "Izvračena knopka",
  "block.minecraft.warped_door": "Izvračene dveri",
  "block.minecraft.warped_fence": "Izvračena ograda",
  "block.minecraft.warped_fence_gate": "Izvračene vrata",
  "block.minecraft.warped_fungus": "Izvračeny grib",
  "block.minecraft.warped_hanging_sign": "Pověšena izvračena vyvěska",
  "block.minecraft.warped_hyphae": "Izvračene hify",
  "block.minecraft.warped_nylium": "Izvračena podgribja",
  "block.minecraft.warped_planks": "Izvračene dosky",
  "block.minecraft.warped_pressure_plate": "Izvračeny pritiskany platform",
  "block.minecraft.warped_roots": "Izvračene korenje",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Izvračena vyvěska",
  "block.minecraft.warped_slab": "Izvračeny platform",
  "block.minecraft.warped_stairs": "Izvračene stupenišče",
  "block.minecraft.warped_stem": "Izvračeno steblo",
  "block.minecraft.warped_trapdoor": "Izvračeny otvor",
  "block.minecraft.warped_wall_hanging_sign": "Nastěnna pověšena izvračena vyvěska",
  "block.minecraft.warped_wall_sign": "Nastěnna izvračena vyvěska",
  "block.minecraft.warped_wart_block": "Bradavičny izvračeny blok",
  "block.minecraft.water": "Voda",
  "block.minecraft.water_cauldron": "Kotel s vodoju",
  "block.minecraft.waxed_chiseled_copper": "Voščeny vrubany měd",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Voščeny blok měda",
  "block.minecraft.waxed_copper_bulb": "Voščena mědna lukovica",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Voščena mědna skrinja",
  "block.minecraft.waxed_copper_door": "Voščene mědne dveri",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Voščeny mědny gril",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Voščeny mědny otvor",
  "block.minecraft.waxed_cut_copper": "Voščeny pileny blok mědi",
  "block.minecraft.waxed_cut_copper_slab": "Voščeny pileny mědny platform",
  "block.minecraft.waxed_cut_copper_stairs": "Voščeno pileno mědno stupenišče",
  "block.minecraft.waxed_exposed_chiseled_copper": "Voščeny izstavjeny vrubany měd",
  "block.minecraft.waxed_exposed_copper": "Voščeny izstavjeny měd",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Voščena izstavjena mědna lukovica",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Voščena izstavjena mědna skrinja",
  "block.minecraft.waxed_exposed_copper_door": "Voščene izstavjene mědne dveri",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Voščeny izstavjeny mědny gril",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Voščeny izstavjeny mědny otvor",
  "block.minecraft.waxed_exposed_cut_copper": "Voščeny izstavjeny pileny měd",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Voščeny izstavjeny pileny mědny platform",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Voščene izstavjene pilene mědne stupenišče",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Voščeny oksidny vrubany měd",
  "block.minecraft.waxed_oxidized_copper": "Voščeny oksidny block mědi",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Voščena oksidna mědna lukovica",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Voščena oksidna mědna skrinja",
  "block.minecraft.waxed_oxidized_copper_door": "Voščene oksidne mědne dveri",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Voščeny oksidny mědny gril",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Voščeny oksidny mědny otvor",
  "block.minecraft.waxed_oxidized_cut_copper": "Voščena oksidna pilena měd",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Voščeny oksidny pileny mědny platform",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Voščeno oksidno pileno mědno stupenišče",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Voščeny rdžavy vrubany měd",
  "block.minecraft.waxed_weathered_copper": "Voščeny rdžavy blok mědi",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Voščena rdžava mědna lukovica",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Voščena rdžava mědna skrinja",
  "block.minecraft.waxed_weathered_copper_door": "Voščene rdžave mědne dveri",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Voščeny rdžavy mědny gril",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Voščeny rdžavy mědny otvor",
  "block.minecraft.waxed_weathered_cut_copper": "Voščeny rdžavy pileny měd",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Voščeny rdžavy pileny mědny platform",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Voščeno rdžavo pileno mědno stupenišče",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Rdžavy vrubany měd",
  "block.minecraft.weathered_copper": "Rdžavy měd",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Rdžava mědna lukovica",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Rdžava mědna skrinja",
  "block.minecraft.weathered_copper_door": "Rdžave mědne dveri",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Rdžavy mědny gril",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Rdžavy mědny otvor",
  "block.minecraft.weathered_cut_copper": "Rdžavy pileny měd",
  "block.minecraft.weathered_cut_copper_slab": "Rdžavy pileny mědny platform",
  "block.minecraft.weathered_cut_copper_stairs": "Rdžavo stupenišče iz rězanogo mědu",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Plačuče polzavice",
  "block.minecraft.weeping_vines_plant": "Rastuče plačuče polzavice",
  "block.minecraft.wet_sponge": "Mokra guba",
  "block.minecraft.wheat": "Pšenica",
  "block.minecraft.white_banner": "Běla horugva",
  "block.minecraft.white_bed": "Bělo ležišče",
  "block.minecraft.white_candle": "Běla svěča",
  "block.minecraft.white_candle_cake": "Tort s běloju svěčeju",
  "block.minecraft.white_carpet": "Běly koverec",
  "block.minecraft.white_concrete": "Běly beton",
  "block.minecraft.white_concrete_powder": "Běly cement",
  "block.minecraft.white_glazed_terracotta": "Běla glazovana terakota",
  "block.minecraft.white_shulker_box": "Běla šalkerova krabka",
  "block.minecraft.white_stained_glass": "Bělo steklo",
  "block.minecraft.white_stained_glass_pane": "Běly steklěny panel",
  "block.minecraft.white_terracotta": "Běla terakota",
  "block.minecraft.white_tulip": "Běly tulipan",
  "block.minecraft.white_wool": "Běla volna",
  "block.minecraft.wildflowers": "Poljne cvěty",
  "block.minecraft.wither_rose": "Roza vizera",
  "block.minecraft.wither_skeleton_skull": "Čerep vizerovogo skeleta",
  "block.minecraft.wither_skeleton_wall_skull": "Nastěnny čerep vizerovogo skeleta",
  "block.minecraft.yellow_banner": "Žolta horugva",
  "block.minecraft.yellow_bed": "Žolto ležišče",
  "block.minecraft.yellow_candle": "Žolta svěča",
  "block.minecraft.yellow_candle_cake": "Tort s žoltoju svěčeju",
  "block.minecraft.yellow_carpet": "Žolty koverec",
  "block.minecraft.yellow_concrete": "Žolty beton",
  "block.minecraft.yellow_concrete_powder": "Žolty cement",
  "block.minecraft.yellow_glazed_terracotta": "Žolta glazovana terakota",
  "block.minecraft.yellow_shulker_box": "Žolta šalkerova krabka",
  "block.minecraft.yellow_stained_glass": "Žolto steklo",
  "block.minecraft.yellow_stained_glass_pane": "Žolty steklěny panel",
  "block.minecraft.yellow_terracotta": "Žolta terakota",
  "block.minecraft.yellow_wool": "Žolta volna",
  "block.minecraft.zombie_head": "Glava zombe",
  "block.minecraft.zombie_wall_head": "Nastěnna glava zombe",
  "item.minecraft.acacia_boat": "Akacova lodka",
  "item.minecraft.acacia_chest_boat": "Akacova lodka so skrinjeju",
  "item.minecraft.allay_spawn_egg": "Jajce s eleljem",
  "item.minecraft.amethyst_shard": "Čest ametista",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Črěp s rybarom",
  "item.minecraft.apple": "Jabloko",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Črěp so strělcem",
  "item.minecraft.armadillo_scute": "Ščitok bronjenosca",
  "item.minecraft.armadillo_spawn_egg": "Jajce s bronjenoscem",
  "item.minecraft.armor_stand": "Stojak za bronju",
  "item.minecraft.arms_up_pottery_shard": "Rųky v gorų, grnčji råzdrob",
  "item.minecraft.arms_up_pottery_sherd": "Črěp s rukami vgoru",
  "item.minecraft.arrow": "Strěla",
  "item.minecraft.axolotl_bucket": "Vědro s aksolotlom",
  "item.minecraft.axolotl_spawn_egg": "Jajce s aksolotlom",
  "item.minecraft.baked_potato": "Pečeny kartofelj",
  "item.minecraft.bamboo_chest_raft": "Bambusova lodka so skrinjeju",
  "item.minecraft.bamboo_raft": "Bambusova lodka",
  "item.minecraft.bat_spawn_egg": "Jajce s lětajučoju myšju",
  "item.minecraft.bee_spawn_egg": "Jajce s pčeloju",
  "item.minecraft.beef": "Surova govedina",
  "item.minecraft.beetroot": "Cvekla",
  "item.minecraft.beetroot_seeds": "Sěme cvekly",
  "item.minecraft.beetroot_soup": "Boršč",
  "item.minecraft.birch_boat": "Brězova lodka",
  "item.minecraft.birch_chest_boat": "Brězova lodka so skrinjeju",
  "item.minecraft.black_bundle": "Črna Torba",
  "item.minecraft.black_dye": "Črna farba",
  "item.minecraft.black_harness": "Črna uprež",
  "item.minecraft.blade_pottery_shard": "Škydka iz blata",
  "item.minecraft.blade_pottery_sherd": "Črěp s ostrjem",
  "item.minecraft.blaze_powder": "Plamenjcovy prah",
  "item.minecraft.blaze_rod": "Plamenjcovy prut",
  "item.minecraft.blaze_spawn_egg": "Jajce s plamenjcem",
  "item.minecraft.blue_bundle": "Modra Torba",
  "item.minecraft.blue_dye": "Modra farba",
  "item.minecraft.blue_egg": "Modro jajce",
  "item.minecraft.blue_harness": "Modra uprež",
  "item.minecraft.bogged_spawn_egg": "Jajce s bagncem",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Kost",
  "item.minecraft.bone_meal": "Kostna muka",
  "item.minecraft.book": "Kniga",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Luk",
  "item.minecraft.bowl": "Miska",
  "item.minecraft.bread": "Hlěb",
  "item.minecraft.breeze_rod": "Vihrakovy prut",
  "item.minecraft.breeze_spawn_egg": "Jajce s vihrakom",
  "item.minecraft.brewer_pottery_shard": "Plna krema",
  "item.minecraft.brewer_pottery_sherd": "Črěp s napitnikom",
  "item.minecraft.brewing_stand": "Napitnik",
  "item.minecraft.brick": "Cegla",
  "item.minecraft.brown_bundle": "Koričneva Torba",
  "item.minecraft.brown_dye": "Koričneva farba",
  "item.minecraft.brown_egg": "Koričnevo jajce",
  "item.minecraft.brown_harness": "Koričneva uprež",
  "item.minecraft.brush": "Ščetka",
  "item.minecraft.bucket": "Vědro",
  "item.minecraft.bundle": "Rukzak",
  "item.minecraft.bundle.empty": "Pusty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Oplåti grnčji råzdrob",
  "item.minecraft.burn_pottery_sherd": "Črěp s plamenjem",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Jajce s velbludom",
  "item.minecraft.carrot": "Mrkva",
  "item.minecraft.carrot_on_a_stick": "Mrkva na palě",
  "item.minecraft.cat_spawn_egg": "Jajce s kotom",
  "item.minecraft.cauldron": "Kotel",
  "item.minecraft.cave_spider_spawn_egg": "Jajce s jamovym pavukom",
  "item.minecraft.chainmail_boots": "Lancovane obuvky",
  "item.minecraft.chainmail_chestplate": "Lancovany nagrudnik",
  "item.minecraft.chainmail_helmet": "Lancovany šlěm",
  "item.minecraft.chainmail_leggings": "Lancovane nogavice",
  "item.minecraft.charcoal": "Drěvny vugolj",
  "item.minecraft.cherry_boat": "Višnjeva lodka",
  "item.minecraft.cherry_chest_boat": "Višnjeva lodka so skrinjeju",
  "item.minecraft.chest_minecart": "Vagonetka so skrinjeju",
  "item.minecraft.chicken": "Surova kura",
  "item.minecraft.chicken_spawn_egg": "Jajce s kuroju",
  "item.minecraft.chorus_fruit": "Ovoč horusa",
  "item.minecraft.clay_ball": "Glina",
  "item.minecraft.clock": "Časovnik",
  "item.minecraft.coal": "Vugolj",
  "item.minecraft.coast_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Kakaove zrno",
  "item.minecraft.cod": "Surova treska",
  "item.minecraft.cod_bucket": "Vědro s treskoju",
  "item.minecraft.cod_spawn_egg": "Jajce s treskoju",
  "item.minecraft.command_block_minecart": "Vagonetka s blokom prikazov",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Bifštek",
  "item.minecraft.cooked_chicken": "Pečena kura",
  "item.minecraft.cooked_cod": "Pečena treska",
  "item.minecraft.cooked_mutton": "Pečena baranina",
  "item.minecraft.cooked_porkchop": "Pečena veprina",
  "item.minecraft.cooked_rabbit": "Pečeny kralik",
  "item.minecraft.cooked_salmon": "Pečeny losos",
  "item.minecraft.cookie": "Biskvit",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Mědny nagrudnik",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Mědny kovok",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Jajce s kravoju",
  "item.minecraft.creaking_spawn_egg": "Jajce s trěsčnikom",
  "item.minecraft.creeper_banner_pattern": "Črtež horugvy",
  "item.minecraft.creeper_banner_pattern.desc": "Črtež kripera",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Jajce s kriperom",
  "item.minecraft.crossbow": "Samostrěl",
  "item.minecraft.crossbow.projectile": "Kulja:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Turkysova torba",
  "item.minecraft.cyan_dye": "Turkysova farba",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Obezopasny grnčji råzdrob",
  "item.minecraft.danger_pottery_sherd": "Črěp s ogroženjem",
  "item.minecraft.dark_oak_boat": "Mračnodubova lodka",
  "item.minecraft.dark_oak_chest_boat": "Mračnodubova lodka so skrinjeju",
  "item.minecraft.debug_stick": "Debugujuča pala",
  "item.minecraft.debug_stick.empty": "Objekt „%s” ne imaje vlastničstv",
  "item.minecraft.debug_stick.select": "izbrano «%s» (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" na %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantova sěkyra",
  "item.minecraft.diamond_boots": "Diamantove obuvky",
  "item.minecraft.diamond_chestplate": "Diamantovy nagrudnik",
  "item.minecraft.diamond_helmet": "Diamantovy šlěm",
  "item.minecraft.diamond_hoe": "Diamantova motyka",
  "item.minecraft.diamond_horse_armor": "Diamantova konska bronja",
  "item.minecraft.diamond_leggings": "Diamantove nogavice",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Diamantova kopalka",
  "item.minecraft.diamond_shovel": "Diamantova lopata",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Diamantovy meč",
  "item.minecraft.disc_fragment_5": "Odlomok diska",
  "item.minecraft.disc_fragment_5.desc": "Muzikalny disk - 5",
  "item.minecraft.dolphin_spawn_egg": "Jajce s delfinom",
  "item.minecraft.donkey_spawn_egg": "Jajce s oslom",
  "item.minecraft.dragon_breath": "Dyh drakona",
  "item.minecraft.dried_kelp": "Sušena vodna trava",
  "item.minecraft.drowned_spawn_egg": "Jajce s utonenjcem",
  "item.minecraft.dune_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Odlamok eha",
  "item.minecraft.egg": "Jajce",
  "item.minecraft.elder_guardian_spawn_egg": "Jajce s prastražem",
  "item.minecraft.elytra": "Elitra",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Čarovna kniga",
  "item.minecraft.enchanted_golden_apple": "Čarovno zlato jabloko",
  "item.minecraft.end_crystal": "Endovy kristal",
  "item.minecraft.ender_dragon_spawn_egg": "Jajce s drakonom Endu",
  "item.minecraft.ender_eye": "Oko endera",
  "item.minecraft.ender_pearl": "Ender-perla",
  "item.minecraft.enderman_spawn_egg": "Jajce s endermanom",
  "item.minecraft.endermite_spawn_egg": "Jajce s endermitom",
  "item.minecraft.evoker_spawn_egg": "Jajce s privoditeljem",
  "item.minecraft.experience_bottle": "Čarovna fljaška",
  "item.minecraft.explorer_pottery_shard": "Eksplorator",
  "item.minecraft.explorer_pottery_sherd": "Črěp s izslědovateljem",
  "item.minecraft.eye_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Pero",
  "item.minecraft.fermented_spider_eye": "Izkvašeno oko pavuka",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Ognjena kulja",
  "item.minecraft.firework_rocket": "Fejerverk",
  "item.minecraft.firework_rocket.flight": "Dolgost leta:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Zvězdka pirotehnična",
  "item.minecraft.firework_star.black": "Črny",
  "item.minecraft.firework_star.blue": "Sinji",
  "item.minecraft.firework_star.brown": "Koričnevy",
  "item.minecraft.firework_star.custom_color": "Sobstveny",
  "item.minecraft.firework_star.cyan": "Turkysovy",
  "item.minecraft.firework_star.fade_to": "Prěhodeči v",
  "item.minecraft.firework_star.flicker": "Iskrenje",
  "item.minecraft.firework_star.gray": "Sivy",
  "item.minecraft.firework_star.green": "Zeleny",
  "item.minecraft.firework_star.light_blue": "Světlomodry",
  "item.minecraft.firework_star.light_gray": "Jasnosivy",
  "item.minecraft.firework_star.lime": "Jasnozeleny",
  "item.minecraft.firework_star.magenta": "Purpurny",
  "item.minecraft.firework_star.orange": "Oranževy",
  "item.minecraft.firework_star.pink": "Rozovy",
  "item.minecraft.firework_star.purple": "Fioletovy",
  "item.minecraft.firework_star.red": "Črveny",
  "item.minecraft.firework_star.shape": "Neizvěstny oblik",
  "item.minecraft.firework_star.shape.burst": "Izbuh",
  "item.minecraft.firework_star.shape.creeper": "Oblik kripera",
  "item.minecraft.firework_star.shape.large_ball": "Duža kulja",
  "item.minecraft.firework_star.shape.small_ball": "Mala kulja",
  "item.minecraft.firework_star.shape.star": "Oblik zvězdy",
  "item.minecraft.firework_star.trail": "Slěd",
  "item.minecraft.firework_star.white": "Běly",
  "item.minecraft.firework_star.yellow": "Žolty",
  "item.minecraft.fishing_rod": "Vudačka",
  "item.minecraft.flint": "Kremenj",
  "item.minecraft.flint_and_steel": "Zapalnička",
  "item.minecraft.flow_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Črtež horugvy",
  "item.minecraft.flow_banner_pattern.desc": "Tok",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Črěp s tokom",
  "item.minecraft.flower_banner_pattern": "Črtež horugvy",
  "item.minecraft.flower_banner_pattern.desc": "Črtež cvěta",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Cvětny grn",
  "item.minecraft.fox_spawn_egg": "Jajce s lisom",
  "item.minecraft.friend_pottery_shard": "Prijateljsky grnčji komad",
  "item.minecraft.friend_pottery_sherd": "Črěp s drugom",
  "item.minecraft.frog_spawn_egg": "Jajce s žaboju",
  "item.minecraft.furnace_minecart": "Vagonetka s pečem",
  "item.minecraft.ghast_spawn_egg": "Jajce s gastom",
  "item.minecraft.ghast_tear": "Solza gasta",
  "item.minecraft.glass_bottle": "Steklěna fljaška",
  "item.minecraft.glistering_melon_slice": "Kusok blěskajučej dynje",
  "item.minecraft.globe_banner_pattern": "Črtež horugvy",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Světle jagody",
  "item.minecraft.glow_ink_sac": "Světly měšek so črnilom",
  "item.minecraft.glow_item_frame": "Světla oprava na prědmet",
  "item.minecraft.glow_squid_spawn_egg": "Jajce so blěstějučim sprutom",
  "item.minecraft.glowstone_dust": "Světlokamenny prah",
  "item.minecraft.goat_horn": "Rog kozy",
  "item.minecraft.goat_spawn_egg": "Jajce s kozoju",
  "item.minecraft.gold_ingot": "Zlaty kovok",
  "item.minecraft.gold_nugget": "Zlaty samorod",
  "item.minecraft.golden_apple": "Zlato jabloko",
  "item.minecraft.golden_axe": "Zlata sěkyra",
  "item.minecraft.golden_boots": "Zlate obuvky",
  "item.minecraft.golden_carrot": "Zlata mrkva",
  "item.minecraft.golden_chestplate": "Zlaty nagrudnik",
  "item.minecraft.golden_helmet": "Zlaty šlěm",
  "item.minecraft.golden_hoe": "Zlata motyka",
  "item.minecraft.golden_horse_armor": "Zlata konska bronja",
  "item.minecraft.golden_leggings": "Zlate nogavice",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Zlata kopalka",
  "item.minecraft.golden_shovel": "Zlata lopata",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Zlaty meč",
  "item.minecraft.gray_bundle": "Sěra Torba",
  "item.minecraft.gray_dye": "Siva farba",
  "item.minecraft.gray_harness": "Siva uprež",
  "item.minecraft.green_bundle": "Zelena Torba",
  "item.minecraft.green_dye": "Zelena farba",
  "item.minecraft.green_harness": "Zelena uprež",
  "item.minecraft.guardian_spawn_egg": "Jajce so stražem",
  "item.minecraft.gunpowder": "Izbuhlivy prah",
  "item.minecraft.guster_banner_pattern": "Črtež horugvy",
  "item.minecraft.guster_banner_pattern.desc": "Poryv",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Črěp s poryvom",
  "item.minecraft.happy_ghast_spawn_egg": "Jajce s veselym gastom",
  "item.minecraft.harness": "Uprež",
  "item.minecraft.heart_of_the_sea": "Morsko srdce",
  "item.minecraft.heart_pottery_shard": "Srdečny grnčji odlomk",
  "item.minecraft.heart_pottery_sherd": "Črěp so srdcem",
  "item.minecraft.heartbreak_pottery_shard": "Srdcebrěmenny grnčji råzdrob",
  "item.minecraft.heartbreak_pottery_sherd": "Črěp so slomjenom srdcem",
  "item.minecraft.hoglin_spawn_egg": "Jajce s hoglinom",
  "item.minecraft.honey_bottle": "Fljaška meda",
  "item.minecraft.honeycomb": "Šestikutnik pčel",
  "item.minecraft.hopper_minecart": "Vagonetka s nasypnikom",
  "item.minecraft.horse_spawn_egg": "Jajce s konjem",
  "item.minecraft.host_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Črka",
  "item.minecraft.howl_pottery_sherd": "Črěp s cviljenjem",
  "item.minecraft.husk_spawn_egg": "Jajce s pustynnikom",
  "item.minecraft.ink_sac": "Měšek so črnilom",
  "item.minecraft.iron_axe": "Želězna sěkyra",
  "item.minecraft.iron_boots": "Železne obuvky",
  "item.minecraft.iron_chestplate": "Železny nagrudnik",
  "item.minecraft.iron_golem_spawn_egg": "Jajce s želěznym golemom",
  "item.minecraft.iron_helmet": "Železny šlěm",
  "item.minecraft.iron_hoe": "Želězna motyka",
  "item.minecraft.iron_horse_armor": "Želězna konska bronja",
  "item.minecraft.iron_ingot": "Želězny kovok",
  "item.minecraft.iron_leggings": "Železne nogavice",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Želězny samorod",
  "item.minecraft.iron_pickaxe": "Želězna kopalka",
  "item.minecraft.iron_shovel": "Želězna lopata",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Želězny meč",
  "item.minecraft.item_frame": "Oprava na prědmet",
  "item.minecraft.jungle_boat": "Džunglova lodka",
  "item.minecraft.jungle_chest_boat": "Džunglova lodka so skrinjeju",
  "item.minecraft.knowledge_book": "Kniga vědy",
  "item.minecraft.lapis_lazuli": "Lazurit",
  "item.minecraft.lava_bucket": "Vědro s lavoju",
  "item.minecraft.lead": "Vodilo",
  "item.minecraft.leather": "Koža",
  "item.minecraft.leather_boots": "Kožene obuvky",
  "item.minecraft.leather_chestplate": "Koženy plašč",
  "item.minecraft.leather_helmet": "Kožena šapka",
  "item.minecraft.leather_horse_armor": "Kožena konska bronja",
  "item.minecraft.leather_leggings": "Kožene nogavky",
  "item.minecraft.light_blue_bundle": "Světlomodra Torba",
  "item.minecraft.light_blue_dye": "Světlomodra farba",
  "item.minecraft.light_blue_harness": "Světlomodra uprež",
  "item.minecraft.light_gray_bundle": "Světlosěra Torba",
  "item.minecraft.light_gray_dye": "Jasnosiva farba",
  "item.minecraft.light_gray_harness": "Jasnosiva uprež",
  "item.minecraft.lime_bundle": "Světlozelena Torba",
  "item.minecraft.lime_dye": "Jasnozelena farba",
  "item.minecraft.lime_harness": "Jasnozelena uprež",
  "item.minecraft.lingering_potion": "Dolgotrajny magičny napitok",
  "item.minecraft.lingering_potion.effect.awkward": "Dolgotrajny čudny napitok",
  "item.minecraft.lingering_potion.effect.empty": "Dolgotrajny neiztvarjalny napitok",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Dolgotrajny napitok ognjeodpornosti",
  "item.minecraft.lingering_potion.effect.harming": "Dolgotrajny napitok krivdy",
  "item.minecraft.lingering_potion.effect.healing": "Dolgotrajny napitok lěčenja",
  "item.minecraft.lingering_potion.effect.infested": "Dolgotrajny napitok črvivosti",
  "item.minecraft.lingering_potion.effect.invisibility": "Dolgotrajny napitok nevidimosti",
  "item.minecraft.lingering_potion.effect.leaping": "Dolgotrajny napitok skoka",
  "item.minecraft.lingering_potion.effect.levitation": "Dolgotrajny napitok levitacije",
  "item.minecraft.lingering_potion.effect.luck": "Dolgotrajny napitok ščestja",
  "item.minecraft.lingering_potion.effect.mundane": "Dolgotrajny obyčajny napitok",
  "item.minecraft.lingering_potion.effect.night_vision": "Dolgotrajny napitok viděnja v mraku",
  "item.minecraft.lingering_potion.effect.oozing": "Dolgotrajny napitok gnojenja se",
  "item.minecraft.lingering_potion.effect.poison": "Dolgotrajny napitok jada",
  "item.minecraft.lingering_potion.effect.regeneration": "Dolgotrajny napitok regeneracije",
  "item.minecraft.lingering_potion.effect.slow_falling": "Dolgotrajny napitok medlogo upada",
  "item.minecraft.lingering_potion.effect.slowness": "Dolgotrajny napitok nebystri",
  "item.minecraft.lingering_potion.effect.strength": "Dolgotrajny napitok sily",
  "item.minecraft.lingering_potion.effect.swiftness": "Dolgotrajny napitok bystrosti",
  "item.minecraft.lingering_potion.effect.thick": "Dolgotrajny slaby napitok",
  "item.minecraft.lingering_potion.effect.turtle_master": "Dolgotrajny napitok majstra žolvov",
  "item.minecraft.lingering_potion.effect.water": "Dolgotrajna fljaška vody",
  "item.minecraft.lingering_potion.effect.water_breathing": "Dolgotrajny napitok podvodnogo dyhanja",
  "item.minecraft.lingering_potion.effect.weakness": "Dolgotrajny napitok slabosti",
  "item.minecraft.lingering_potion.effect.weaving": "Dolgotrajny napitok vitja",
  "item.minecraft.lingering_potion.effect.wind_charged": "Dolgotrajny napitok razdutja",
  "item.minecraft.llama_spawn_egg": "Jajce s lamoju",
  "item.minecraft.lodestone_compass": "Izdvojicovany kompas",
  "item.minecraft.mace": "Bulava",
  "item.minecraft.magenta_bundle": "Purpurna Torba",
  "item.minecraft.magenta_dye": "Purpurna farba",
  "item.minecraft.magenta_harness": "Purpurna uprež",
  "item.minecraft.magma_cream": "Magmovy krem",
  "item.minecraft.magma_cube_spawn_egg": "Jajce s kostkoju magmy",
  "item.minecraft.mangrove_boat": "Mangrova lodka",
  "item.minecraft.mangrove_chest_boat": "Mangrova lodka so skrinjeju",
  "item.minecraft.map": "Pusta mapa",
  "item.minecraft.melon_seeds": "Sěme dynje",
  "item.minecraft.melon_slice": "Kusok dynje",
  "item.minecraft.milk_bucket": "Vědro s mlěkom",
  "item.minecraft.minecart": "Vagonetka",
  "item.minecraft.miner_pottery_shard": "Gruzdnik",
  "item.minecraft.miner_pottery_sherd": "Črěp s gornikom",
  "item.minecraft.mojang_banner_pattern": "Črtež horugvy",
  "item.minecraft.mojang_banner_pattern.desc": "Prědmet",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Jajce s mušrumom",
  "item.minecraft.mourner_pottery_shard": "Smųtnik",
  "item.minecraft.mourner_pottery_sherd": "Črěp s oplakyvateljem",
  "item.minecraft.mule_spawn_egg": "Jajce s mulom",
  "item.minecraft.mushroom_stew": "Gribna supa",
  "item.minecraft.music_disc_11": "Muzikalny disk",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Muzikalny disk",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Muzikalny disk",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Muzikalny disk",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Muzikalny disk",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Muzikalny disk",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Muzikalny disk",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Muzikalny disk",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (muzikalna škatulka)",
  "item.minecraft.music_disc_far": "Muzikalny disk",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Muzikalny disk",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Muzikalny disk",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Muzikalny disk",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Muzikalny disk",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Muzikalny disk",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Muzikovy disk",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof — Relic",
  "item.minecraft.music_disc_stal": "Muzikalny disk",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Muzikalny disk",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Muzikalny disk",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Muzikalny disk",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Surova baranina",
  "item.minecraft.name_tag": "Imenna značka",
  "item.minecraft.nautilus_shell": "Skorlupa nautilusa",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Nezerova cegla",
  "item.minecraft.nether_star": "Zvězda nezera",
  "item.minecraft.nether_wart": "Nezerova bradavica",
  "item.minecraft.netherite_axe": "Nezeritova sěkyra",
  "item.minecraft.netherite_boots": "Nezeritove obuvky",
  "item.minecraft.netherite_chestplate": "Nezeritovy nagrudnik",
  "item.minecraft.netherite_helmet": "Nezeritovy šlěm",
  "item.minecraft.netherite_hoe": "Nezeritova motyka",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Nezeritovy kovok",
  "item.minecraft.netherite_leggings": "Nezeritove nogavice",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Nezeritova kopalka",
  "item.minecraft.netherite_scrap": "Kus nezerita",
  "item.minecraft.netherite_shovel": "Nezeritova lopata",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Nezeritovy meč",
  "item.minecraft.netherite_upgrade_smithing_template": "Kovačsky šablon",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Nezeritove ulěpšenje",
  "item.minecraft.oak_boat": "Dubova lodka",
  "item.minecraft.oak_chest_boat": "Dubova lodka so skrinjeju",
  "item.minecraft.ocelot_spawn_egg": "Jajce s ocelotom",
  "item.minecraft.ominous_bottle": "Zlověstna fljaška",
  "item.minecraft.ominous_trial_key": "Zlověstny ključ izzva",
  "item.minecraft.orange_bundle": "Oranževa Torba",
  "item.minecraft.orange_dye": "Oranževa farba",
  "item.minecraft.orange_harness": "Oranževa uprež",
  "item.minecraft.painting": "Obraz",
  "item.minecraft.pale_oak_boat": "Blědodubova lodka",
  "item.minecraft.pale_oak_chest_boat": "Blědodubova lodka so skrinjeju",
  "item.minecraft.panda_spawn_egg": "Jace s pandoju",
  "item.minecraft.paper": "Papir",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Jajce s papugajem",
  "item.minecraft.phantom_membrane": "Blana prizraka",
  "item.minecraft.phantom_spawn_egg": "Jajce s prizrakom",
  "item.minecraft.pig_spawn_egg": "Jajce so svinjoju",
  "item.minecraft.piglin_banner_pattern": "Črtež horugvy",
  "item.minecraft.piglin_banner_pattern.desc": "Rylo",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Jajce so žestokym piglinom",
  "item.minecraft.piglin_spawn_egg": "Jajce s piglinom",
  "item.minecraft.pillager_spawn_egg": "Jajce s razbojnikom",
  "item.minecraft.pink_bundle": "Rozova torba",
  "item.minecraft.pink_dye": "Rozova farba",
  "item.minecraft.pink_harness": "Rozova uprež",
  "item.minecraft.pitcher_plant": "Kamenja",
  "item.minecraft.pitcher_pod": "Klop",
  "item.minecraft.plenty_pottery_shard": "Bųde mnogo krvnyh råzdrobk",
  "item.minecraft.plenty_pottery_sherd": "Črěp s dostatkom",
  "item.minecraft.poisonous_potato": "Otravny kartofelj",
  "item.minecraft.polar_bear_spawn_egg": "Jajce s polarnym medvědom",
  "item.minecraft.popped_chorus_fruit": "Vypukany ovoč horusa",
  "item.minecraft.porkchop": "Surova veprina",
  "item.minecraft.potato": "Kartofelj",
  "item.minecraft.potion": "Magičny napitok",
  "item.minecraft.potion.effect.awkward": "Čudny napitok",
  "item.minecraft.potion.effect.empty": "Neiztvarjalny napitok",
  "item.minecraft.potion.effect.fire_resistance": "Napitok ognjeodpornosti",
  "item.minecraft.potion.effect.harming": "Napitok krivdy",
  "item.minecraft.potion.effect.healing": "Napitok lěčenja",
  "item.minecraft.potion.effect.infested": "Napitok črvivosti",
  "item.minecraft.potion.effect.invisibility": "Napitok nevidimosti",
  "item.minecraft.potion.effect.leaping": "Napitok skoka",
  "item.minecraft.potion.effect.levitation": "Napitok levitacije",
  "item.minecraft.potion.effect.luck": "Napitok ščestja",
  "item.minecraft.potion.effect.mundane": "Obyčajny napitok",
  "item.minecraft.potion.effect.night_vision": "Napitok viděnja v mraku",
  "item.minecraft.potion.effect.oozing": "Napitok gnojenja se",
  "item.minecraft.potion.effect.poison": "Napitok jada",
  "item.minecraft.potion.effect.regeneration": "Napitok regeneracije",
  "item.minecraft.potion.effect.slow_falling": "Napitok medlogo upada",
  "item.minecraft.potion.effect.slowness": "Napitok nebystri",
  "item.minecraft.potion.effect.strength": "Napitok sily",
  "item.minecraft.potion.effect.swiftness": "Napitok bystrosti",
  "item.minecraft.potion.effect.thick": "Slaby napitok",
  "item.minecraft.potion.effect.turtle_master": "Napitok majstra žolvov",
  "item.minecraft.potion.effect.water": "Fljaška vody",
  "item.minecraft.potion.effect.water_breathing": "Napitok podvodnogo dyhanja",
  "item.minecraft.potion.effect.weakness": "Napitok slabosti",
  "item.minecraft.potion.effect.weaving": "Napitok vitja",
  "item.minecraft.potion.effect.wind_charged": "Napitok razdutja",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Rųky v gorų, grnčji råzdrob",
  "item.minecraft.pottery_shard_prize": "Nagrađeny grnčji råzdrob",
  "item.minecraft.pottery_shard_skull": "Črka",
  "item.minecraft.powder_snow_bucket": "Vědro s prašekom sněgom",
  "item.minecraft.prismarine_crystals": "Kristaly prizmarina",
  "item.minecraft.prismarine_shard": "Črěp prizmarina",
  "item.minecraft.prize_pottery_shard": "Nagrađeny grnčji råzdrob",
  "item.minecraft.prize_pottery_sherd": "Črěp s nagradoju",
  "item.minecraft.pufferfish": "Naduvač",
  "item.minecraft.pufferfish_bucket": "Vědro s naduvačem",
  "item.minecraft.pufferfish_spawn_egg": "Jajce s naduvačem",
  "item.minecraft.pumpkin_pie": "Tykvova galeta",
  "item.minecraft.pumpkin_seeds": "Sěme tykvy",
  "item.minecraft.purple_bundle": "Fioletova Torba",
  "item.minecraft.purple_dye": "Fioletova farba",
  "item.minecraft.purple_harness": "Fioletova uprež",
  "item.minecraft.quartz": "Kvarc nezera",
  "item.minecraft.rabbit": "Surovy kralik",
  "item.minecraft.rabbit_foot": "Lapa kralika",
  "item.minecraft.rabbit_hide": "Koža kralika",
  "item.minecraft.rabbit_spawn_egg": "Jajce s kralikom",
  "item.minecraft.rabbit_stew": "Supa iz kralika",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Jajce s niščiteljem",
  "item.minecraft.raw_copper": "Surovy měd",
  "item.minecraft.raw_gold": "Surove zlato",
  "item.minecraft.raw_iron": "Surove želězo",
  "item.minecraft.recovery_compass": "Povratny kompas",
  "item.minecraft.red_bundle": "Črvena Torba",
  "item.minecraft.red_dye": "Črvena farba",
  "item.minecraft.red_harness": "Črvena uprež",
  "item.minecraft.redstone": "Redstoun",
  "item.minecraft.resin_brick": "Smolova cegla",
  "item.minecraft.resin_clump": "Gruda smoly",
  "item.minecraft.rib_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Gnilo meso",
  "item.minecraft.saddle": "Sedlo",
  "item.minecraft.salmon": "Surovy losos",
  "item.minecraft.salmon_bucket": "Vědro s lososem",
  "item.minecraft.salmon_spawn_egg": "Jajce s lososom",
  "item.minecraft.scrape_pottery_sherd": "Črěp so strugačom",
  "item.minecraft.scute": "Ščitok",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Šapka",
  "item.minecraft.sheaf_pottery_sherd": "Črěp s baloju",
  "item.minecraft.shears": "Nožice",
  "item.minecraft.sheep_spawn_egg": "Jajce s ovcoju",
  "item.minecraft.shelter_pottery_shard": "Ščitny grnčji odlomk",
  "item.minecraft.shelter_pottery_sherd": "Črěp s uběžiščem",
  "item.minecraft.shield": "Ščit",
  "item.minecraft.shield.black": "Črny ščit",
  "item.minecraft.shield.blue": "Sinji ščit",
  "item.minecraft.shield.brown": "Koričnevy ščit",
  "item.minecraft.shield.cyan": "Turkysovy ščit",
  "item.minecraft.shield.gray": "Sivy ščit",
  "item.minecraft.shield.green": "Zeleny ščit",
  "item.minecraft.shield.light_blue": "Světlomodry ščit",
  "item.minecraft.shield.light_gray": "Jasnosivy ščit",
  "item.minecraft.shield.lime": "Jasnozeleny ščit",
  "item.minecraft.shield.magenta": "Purpurny ščit",
  "item.minecraft.shield.orange": "Oranževy ščit",
  "item.minecraft.shield.pink": "Rozovy ščit",
  "item.minecraft.shield.purple": "Fioletovy ščit",
  "item.minecraft.shield.red": "Črveny ščit",
  "item.minecraft.shield.white": "Běly ščit",
  "item.minecraft.shield.yellow": "Žolty ščit",
  "item.minecraft.shulker_shell": "Skorlupa šalkera",
  "item.minecraft.shulker_spawn_egg": "Jajce so šalkerom",
  "item.minecraft.sign": "Vyvěska",
  "item.minecraft.silence_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Jajce s rybikom",
  "item.minecraft.skeleton_horse_spawn_egg": "Jajce s konjskym skeletom",
  "item.minecraft.skeleton_spawn_egg": "Jajce so skeletom",
  "item.minecraft.skull_banner_pattern": "Črtež horugvy",
  "item.minecraft.skull_banner_pattern.desc": "Črtež čerepa",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Črka",
  "item.minecraft.skull_pottery_sherd": "Črěp so lbom",
  "item.minecraft.slime_ball": "Kulja sliza",
  "item.minecraft.slime_spawn_egg": "Jajce so slizecom",
  "item.minecraft.smithing_template": "Kovačsky šablon",
  "item.minecraft.smithing_template.applies_to": "Nakladaje se na:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Dodaj kovok ili kristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Bronja",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Dodaj čest bronje",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Kovky i kristaly",
  "item.minecraft.smithing_template.ingredients": "Složky:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Dodaj nezeritovy kovok",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantova oprema",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Dodaj diamantovu bronju, oružje, ili orudje",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Nezeritovy kovok",
  "item.minecraft.smithing_template.upgrade": "Nadokradovati: ",
  "item.minecraft.sniffer_spawn_egg": "Jajce s njuhačem",
  "item.minecraft.snort_pottery_shard": "Škrom",
  "item.minecraft.snort_pottery_sherd": "Črěp s njuhom",
  "item.minecraft.snout_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Jajce so sněžnym golemom",
  "item.minecraft.snowball": "Kalina",
  "item.minecraft.spectral_arrow": "Prividna strěla",
  "item.minecraft.spider_eye": "Oko pavuka",
  "item.minecraft.spider_spawn_egg": "Jajce so pavukom",
  "item.minecraft.spire_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Metany magičny napitok",
  "item.minecraft.splash_potion.effect.awkward": "Metany čudny napitok",
  "item.minecraft.splash_potion.effect.empty": "Metany neiztvarjalny napitok",
  "item.minecraft.splash_potion.effect.fire_resistance": "Metany napitok ognjeodpornosti",
  "item.minecraft.splash_potion.effect.harming": "Metany napitok krivdy",
  "item.minecraft.splash_potion.effect.healing": "Metany napitok lěčenja",
  "item.minecraft.splash_potion.effect.infested": "Metany napitok črvivosti",
  "item.minecraft.splash_potion.effect.invisibility": "Metany napitok nevidimosti",
  "item.minecraft.splash_potion.effect.leaping": "Metany napitok skoka",
  "item.minecraft.splash_potion.effect.levitation": "Metany napitok levitacije",
  "item.minecraft.splash_potion.effect.luck": "Metany napitok ščestja",
  "item.minecraft.splash_potion.effect.mundane": "Metany obyčajny napitok",
  "item.minecraft.splash_potion.effect.night_vision": "Metany napitok viděnja v mraku",
  "item.minecraft.splash_potion.effect.oozing": "Metany napitok gnojenja se",
  "item.minecraft.splash_potion.effect.poison": "Metany napitok jada",
  "item.minecraft.splash_potion.effect.regeneration": "Metany napitok regeneracije",
  "item.minecraft.splash_potion.effect.slow_falling": "Metany napitok medlogo upada",
  "item.minecraft.splash_potion.effect.slowness": "Metany napitok nebystri",
  "item.minecraft.splash_potion.effect.strength": "Metany napitok sily",
  "item.minecraft.splash_potion.effect.swiftness": "Metany napitok bystrosti",
  "item.minecraft.splash_potion.effect.thick": "Metany slaby napitok",
  "item.minecraft.splash_potion.effect.turtle_master": "Metany napitok majstra žolvov",
  "item.minecraft.splash_potion.effect.water": "Kydnuta fljaška vody",
  "item.minecraft.splash_potion.effect.water_breathing": "Metany napitok podvodnogo dyhanja",
  "item.minecraft.splash_potion.effect.weakness": "Metany napitok slabosti",
  "item.minecraft.splash_potion.effect.weaving": "Metany napitok vitja",
  "item.minecraft.splash_potion.effect.wind_charged": "Metany napitok razdutja",
  "item.minecraft.spruce_boat": "Smrěkova lodka",
  "item.minecraft.spruce_chest_boat": "Smrěkova lodka so skrinjeju",
  "item.minecraft.spyglass": "Teleskop",
  "item.minecraft.squid_spawn_egg": "Jajce so sprutom",
  "item.minecraft.stick": "Pala",
  "item.minecraft.stone_axe": "Kamenna sěkyra",
  "item.minecraft.stone_hoe": "Kamenna motyka",
  "item.minecraft.stone_pickaxe": "Kamenna kopalka",
  "item.minecraft.stone_shovel": "Kamenna lopata",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Kamenny meč",
  "item.minecraft.stray_spawn_egg": "Jajce s bluditeljem",
  "item.minecraft.strider_spawn_egg": "Jajce s lavohodom",
  "item.minecraft.string": "Nit",
  "item.minecraft.sugar": "Cukr",
  "item.minecraft.suspicious_stew": "Podzrěna supa",
  "item.minecraft.sweet_berries": "Sladke brusnice",
  "item.minecraft.tadpole_bucket": "Vědro s dětetem žaby",
  "item.minecraft.tadpole_spawn_egg": "Jajce s dětetem žaby",
  "item.minecraft.tide_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Obrabotana strěla",
  "item.minecraft.tipped_arrow.effect.awkward": "Obrabotana strěla",
  "item.minecraft.tipped_arrow.effect.empty": "Neiztvarjalna namočena strěla",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Strěla ognjeodpornosti",
  "item.minecraft.tipped_arrow.effect.harming": "Strěla krivdy",
  "item.minecraft.tipped_arrow.effect.healing": "Strěla lěčenja",
  "item.minecraft.tipped_arrow.effect.infested": "Strěla črvivosti",
  "item.minecraft.tipped_arrow.effect.invisibility": "Strěla nevidimosti",
  "item.minecraft.tipped_arrow.effect.leaping": "Strěla skoka",
  "item.minecraft.tipped_arrow.effect.levitation": "Strěla levitacije",
  "item.minecraft.tipped_arrow.effect.luck": "Strěla ščestja",
  "item.minecraft.tipped_arrow.effect.mundane": "Obrabotana strěla",
  "item.minecraft.tipped_arrow.effect.night_vision": "Strěla viděnja v mraku",
  "item.minecraft.tipped_arrow.effect.oozing": "Strěla gnojenja se",
  "item.minecraft.tipped_arrow.effect.poison": "Jadovita strěla",
  "item.minecraft.tipped_arrow.effect.regeneration": "Strěla gojena",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Strěla medlogo upada",
  "item.minecraft.tipped_arrow.effect.slowness": "Strěla nebystri",
  "item.minecraft.tipped_arrow.effect.strength": "Stěla sily",
  "item.minecraft.tipped_arrow.effect.swiftness": "Strěla bystrosti",
  "item.minecraft.tipped_arrow.effect.thick": "Obrabotana strěla",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Strěla majstra žolvov",
  "item.minecraft.tipped_arrow.effect.water": "Strěla bryzganja",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Strěla podvodnogo dyhanja",
  "item.minecraft.tipped_arrow.effect.weakness": "Strěla slabosti",
  "item.minecraft.tipped_arrow.effect.weaving": "Strěla vitja",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Strěla razdutja",
  "item.minecraft.tnt_minecart": "Vagonetka s TNT",
  "item.minecraft.torchflower_seeds": "Torčebrogy",
  "item.minecraft.totem_of_undying": "Totem nesmrteljnosti",
  "item.minecraft.trader_llama_spawn_egg": "Jajce s lamoju kupca",
  "item.minecraft.trial_key": "Ključ izzva",
  "item.minecraft.trident": "Trizubec",
  "item.minecraft.tropical_fish": "Tropična ryba",
  "item.minecraft.tropical_fish_bucket": "Vědro s tropičnoju ryboju",
  "item.minecraft.tropical_fish_spawn_egg": "Jajce s tropičnoju ryboju",
  "item.minecraft.turtle_helmet": "Pancyr žolva",
  "item.minecraft.turtle_scute": "Ščitok žolva",
  "item.minecraft.turtle_spawn_egg": "Jajce so žolvoju",
  "item.minecraft.vex_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Jajce s ogorčateljem",
  "item.minecraft.villager_spawn_egg": "Jajce so seljanom",
  "item.minecraft.vindicator_spawn_egg": "Jajce so mstiteljem",
  "item.minecraft.wandering_trader_spawn_egg": "Jajce s putujučim kupcem",
  "item.minecraft.ward_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Jajce s vardenom",
  "item.minecraft.warped_fungus_on_a_stick": "Izvračeny grib na palě",
  "item.minecraft.water_bucket": "Vědro s vodoju",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Pšenica",
  "item.minecraft.wheat_seeds": "Sěme pšenice",
  "item.minecraft.white_bundle": "Běla Torba",
  "item.minecraft.white_dye": "Běla farba",
  "item.minecraft.white_harness": "Běla uprež",
  "item.minecraft.wild_armor_trim_smithing_template": "Kovačsky šablon",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Větrna kulja",
  "item.minecraft.witch_spawn_egg": "Jajce s vědmoju",
  "item.minecraft.wither_skeleton_spawn_egg": "Jajce s vizerovym skeletom",
  "item.minecraft.wither_spawn_egg": "Jajce s vizerem",
  "item.minecraft.wolf_armor": "Volčja bronja",
  "item.minecraft.wolf_spawn_egg": "Jajce s volkom",
  "item.minecraft.wooden_axe": "Drěvěna sěkyra",
  "item.minecraft.wooden_hoe": "Drěvěna motyka",
  "item.minecraft.wooden_pickaxe": "Drěvěna kopalka",
  "item.minecraft.wooden_shovel": "Drěvěna lopata",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Drěvěny meč",
  "item.minecraft.writable_book": "Kniga s perom",
  "item.minecraft.written_book": "Zapisana kniga",
  "item.minecraft.yellow_bundle": "Žolta Torba",
  "item.minecraft.yellow_dye": "Žolta farba",
  "item.minecraft.yellow_harness": "Žolta uprež",
  "item.minecraft.zoglin_spawn_egg": "Jajce so zoglinom",
  "item.minecraft.zombie_horse_spawn_egg": "Jajce s konjem zombeju",
  "item.minecraft.zombie_nautilus_spawn_egg": "Jajce s nautilusom zombeju",
  "item.minecraft.zombie_spawn_egg": "Jajce s zombeju",
  "item.minecraft.zombie_villager_spawn_egg": "Jajce so seljanom zombeju",
  "item.minecraft.zombified_piglin_spawn_egg": "Jajce so zombizovanym piglinom"
}
export const isv = items; 
